<template>
  <div>

    <div id="fullpage" onclick="this.style.display='none';"></div>
    <!-- <card v-if="!isCustomer ">
      <template v-slot:header>
          <h5 class="d-inline">
          <router-link tag="i" class="fad fa-arrow-right h4 h100 text-secondary ml-3 " to="/app/tickets">
                </router-link>
          <a class="hover-info" href="javascript:;" @click="OnDetailCustomer()">{{ customerName }}</a> <span class="text-danger">شماره تیکت : {{ticketId}}#</span> </h5>
          <i class="fad fa-sort-alt h5 float-left"></i>
      </template>
    </card> -->



    <div class="body">
      <div>
      </div>
      <div class="container">

        <!-- #region LeftSide -->
        <div class="leftSide " v-if="showLeftSide && !isCustomer">

          <div class="pagination p-2 w-100 row" v-if="myTicketPage == 0">
            <div class="col-4 d-flex pointer">
              <span class="pointer" @click="previousPageFiltredTickets()">
                قبلی

              </span>
            </div>
            <div class="col-4 d-flex justify-content-center">
              {{ pageInationFiltredTickets.page }} / {{ pageInationFiltredTickets.totalPage }}
            </div>
            <div class="col-4 ">
              <span class="pointer" @click="nextPageFiltredTickets()">
                بعدی
              </span>
            </div>

          </div>


          <div class="pagination p-2 w-100 row" v-else-if="myTicketPage == 1">
            <div class="col-4 d-flex pointer">
              <span class="pointer" @click="previousPageMyTicket()">
                قبلی

              </span>
            </div>
            <div class="col-4 d-flex justify-content-center">
              {{ pageInationMyTickets.page }} / {{ this.pageInationMyTickets.totalPage }}
            </div>
            <div class="col-4 ">
              <span class="pointer" @click="nextPageMyTicket()">
                بعدی
              </span>
            </div>

          </div>

          <div class="pagination p-2 w-100 row" v-else>
            <div class="col-4 d-flex pointer">
              <span class="pointer" @click="previousPage()">
                قبلی

              </span>
            </div>
            <div class="col-4 d-flex justify-content-center">
              {{ pageInationDepTickets.page }} / {{ this.pageInationDepTickets.totalPage }}
            </div>
            <div class="col-4 ">
              <span class="pointer" @click="nextPage()">
                بعدی
              </span>
            </div>

          </div>


          <!-- Header -->
          <div class="header">
            <h6 class="pointer" @click="initializeFilteredTicket(); myTicketPage = 0"
              :class="[myTicketPage == 0 ? ['text-danger'] : ['']]">
              تیکت های جاری
            </h6>
            <h6>||</h6>
            <h6 class="pointer" @click="myTicket(); myTicketPage = 1"
              :class="[myTicketPage == 1 ? ['text-danger'] : ['']]">
              تیکت های من
            </h6>
            <h6>||</h6>
            <h6 class="pointer" @click="getDeaprtmentTicket(false)"
              :class="[myTicketPage == 2 ? ['text-danger'] : ['']]">
              تیکت های دپارتمان
            </h6>

            <!-- <div class="alert p-1 pointer" :class="[myTicketPage ? ['alert-success'] : ['alert-info']]">
              <span @click="getNotifMyTick()" v-if="myTicketPage">
                   {{notifMyTicket}}
                </span>

                <span @click="getNotifDepTick()" v-else>
                   {{notifDepTicket}}
                </span>
            </div> -->
          </div>
          <!-- CHAT LIST -->
          <!-- تیکت های جاری -->
          <div class="chatlist border-bottom" v-if="myTicketPage == 0">
            <div v-for="item in filterdTickets" :key="item.Id"
              @click="switchChatRoom(item.TblChatRoomId, item.CustomerName, item.CustomerCode, item.Id, item.TblComboGrpId41, item.TblUserId, item.TblCustomerId, item)"
              :data-title="'#' + item.Id">
              <div class="block" :class="[item.Id == ticketId ? ['active'] : '']">
                <a>
                  <div class="imgBox">
                    <img :src="item.CustomerLogo" class="cover" alt="" />
                  </div>
                </a>

                <div class="details">
                  <a>
                    <div class="listHead">
                      <h4 :style="[1664,1656,1312].includes(item.tblCombogrp37AxarinVazeit) ? 'color: #fd5f00 !important;' : ''">{{ item.CustomerName }}</h4>
                      <p class="time">{{ item.DateTimeLastEdit }}</p>
                    </div>
                  </a>

                  <div class="message_p row">
                    <div class="d-block col-12 text-left">
                      <p class="d-block">{{ item.Title }}</p>
                    </div>

                    <div class="col-12">
                      <div class="row">
                        <!-- <b-dropdown size="md" variant="link" class="d-block" text=""
                          toggle-class="text-decoration-none d-block" no-caret v-if="render">
                          <template #button-content>
                            <div class="d-block">
                              <i class="fal fa-info-circle hover-warning text-secondary" />
                            </div>
                          </template>
                          <b-dropdown-item v-for="(status, index) in ticketStatus" :key="index"
                            @click="changeStatus(status.id, item.Id, status.name, item)" class="text-center"
                            :class="[status.id == item.TblComboGrpId41 ? ['bg-success'] : ['']]">
                            {{ status.name }}
                          </b-dropdown-item>
                        </b-dropdown> -->
                        <span style="color: var(--sidebar-color-item) !important">{{ item.NameGrp41 }}</span>
                        <b class="mt-1 ml-2" v-if="item.UnseenMessage > 0">{{ item.UnseenMessage }}</b>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- تیکت های من -->
          <div class="chatlist border-bottom" v-if="myTicketPage == 1">
            <div v-for="item in myTickets" :key="item.Id"
              @click="switchChatRoom(item.TblChatRoomId, item.CustomerName, item.CustomerCode, item.Id, item.TblComboGrpId41, item.TblUserId, item.TblCustomerId, item)">
              <div class="block" :class="[item.Id == ticketId ? ['active'] : '']"
                v-if="item.TblComboGrpId41 != 1792" :data-title="'#' + item.Id">
                <a>
                  <div class="imgBox">
                    <img :src="item.CustomerLogo" class="cover" alt="" />
                  </div>
                </a>

                <div class="details">
                  <a>
                    <div class="listHead">
                      <h4 :style="[1664,1656,1312].includes(item.tblCombogrp37AxarinVazeit) ? 'color: #fd5f00 !important;' : ''">{{ item.CustomerName }}</h4>
                      <!-- <h4>{{ item.Title }}</h4> -->
                      <p class="time">{{ item.DateTimeLastEdit }}</p>
                    </div>
                  </a>

                  <div class="message_p row">
                    <div class="d-block col-12 text-left">
                      <!-- <p class="d-block">{{ item.CustomerName }}</p> -->
                      <p class="d-block text-primary"> {{ item.Title }}</p>
                    </div>

                    <div class="col-12">
                      <div class="row">
                        <!-- <b-dropdown size="md" variant="link" class="d-block" text=""
                          toggle-class="text-decoration-none d-block" no-caret>
                          <template #button-content>
                            <div class="d-block">
                              <i class="fal fa-info-circle hover-warning text-secondary" />
                            </div>
                          </template>
                          <b-dropdown-item v-for="(status, index) in ticketStatus" :key="index"
                            @click="changeStatus(status.id, item.Id, status.name, item)" class="text-center"
                            :class="[status.id == item.TblComboGrpId41 ? ['bg-success'] : ['']]">
                            {{ status.name }}
                          </b-dropdown-item>
                        </b-dropdown> -->
                        <span style="color: var(--sidebar-color-item) !important">{{ item.NameGrp41 }}</span>
                        <b class="mt-1 ml-2" v-if="item.UnseenMessage > 0">{{ item.UnseenMessage }}</b>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- <div class="block unread">
                            <div class="imgBox">
                                <img src="@/assets/ticket.png" class="cover" alt="">
                            </div>
                            <div class="details">
                                <div class="listHead">
                                    <h4>Andre</h4>
                                    <p class="time">12:34</p>
                                </div>
                                <div class="message_p">
                                    <p>I love your youtube videos!</p>
                                    <b>1</b>
                                </div>
                            </div>
                        </div> -->
          </div>
          <!-- تیکت های دپارتمان -->
          <div class="chatlist border-bottom" v-if="myTicketPage == 2">
            <div v-for="item in DeaprtmentTicket" :key="item.Id"
              @click="switchChatRoom(item.TblChatRoomId, item.CustomerName, item.CustomerCode, item.Id, item.TblComboGrpId41, item.TblUserId, item.TblCustomerId, item)"
              :data-title="'#' + item.Id">
              <div class="block" :class="[item.Id == ticketId ? ['active'] : '']">
                <a>
                  <div class="imgBox">
                    <img :src="item.CustomerLogo" class="cover" alt="" />
                  </div>
                </a>

                <div class="details">
                  <a>
                    <div class="listHead">
                      <h4 :style="[1664,1656,1312].includes(item.tblCombogrp37AxarinVazeit) ? 'color: #fd5f00 !important;' : ''">{{ item.CustomerName }}</h4>
                      <p class="time">{{ item.DateTimeLastEdit }}</p>
                    </div>
                  </a>

                  <div class="message_p row">
                    <div class="d-block col-12 text-left">
                      <p class="d-block">{{ item.Title }}</p>
                    </div>

                    <div class="col-12">
                      <div class="row">
                        <!-- <b-dropdown size="md" variant="link" class="d-block" text=""
                          toggle-class="text-decoration-none d-block" no-caret v-if="render">
                          <template #button-content>
                            <div class="d-block">
                              <i class="fal fa-info-circle hover-warning text-secondary" />
                            </div>
                          </template>
                          <b-dropdown-item v-for="(status, index) in ticketStatus" :key="index"
                            @click="changeStatus(status.id, item.Id, status.name, item)" class="text-center"
                            :class="[status.id == item.TblComboGrpId41 ? ['bg-success'] : ['']]">
                            {{ status.name }}
                          </b-dropdown-item>
                        </b-dropdown> -->
                        <span style="color: var(--sidebar-color-item) !important">{{ item.NameGrp41 }}</span>
                        <b class="mt-1 ml-2" v-if="item.UnseenMessage > 0">{{ item.UnseenMessage }}</b>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


        </div>
        <!-- #endregion -->

        <!-- #region RithtSide -->
        <div class="rightSide">
          <!-- #region RightSide_Header -->
          <div class="header ">

            <div v-if="!isCustomer" class="row" style="width: 15%;">
              <div>
                <i class="fas fa-bars text-light Pointer" @click="collapseLeftSide()"></i>
              </div>
              <div>
                <i class="fad fa-sort-alt h5 mx-2 hover-info Pointer" title="مرتب سازی پیام"
                  @click="sortMessageChange()"></i>
              </div>
              <div>
                <i class="fa-duotone fa-cog px-2 h5 Pointer" title="تنظیمات تیکت"
                  style="color:var(--logo-color) !important" @click="showModalTicketStatus()"></i>
              </div>
              <div>
                <i class="fas Pointer fa-times text-danger hover-info px-2 h5" title="بستن تیکت"
                  @click="closeTicket()"></i>
              </div>
            </div>


            <div dir="rtl" class="justify-content-start d-flex w-100" v-if="!isCustomer" style="width: 90%;">
              <div class="row">
                <div class="">
                  <router-link tag="i" class="fad fa-arrow-right h5 h100 text-secondary ml-3" to="/app/tickets">
                  </router-link>
                </div>
                <div>
                  <a class="hover-info" :class="[1664,1656,1312].includes(tblCombogrp37AxarinVazeit)?'text-danger':''" @click="OnDetailCustomer($event)" @click.middle="OnDetailCustomer($event)">
                    {{ customerName }}</a> <span
                    class="text-danger h6">شماره تیکت : {{ ticketId }}#</span>
                  <a @click="OnDetail(ticketId)"> <i class="fas fa-info mx-2 mb-2 hover-warning"
                      title="لاگ تیکت"></i></a>
                </div>

                <div class="mr-2 mb-2 row" id="online-user" v-if="!isCustomer">
                  <div v-for="(item, index) in onlineUserChatRoom" :key="index" class="ml-2">
                    <span class="mx-2 mb-3" style="font-size: 12.5px;">{{ item }} در حال مشاهده تیکت</span>
                    <div class="rounded bg-success" style="width: 8px;height: 8px;"></div>
                  </div>
                </div>
              </div>
            </div>

            <!-- <div class="header-info p-2" v-if="!isCustomer" >
              <h5 class="d-inline">
              <router-link tag="i" class="fad fa-arrow-right h4 h100 text-secondary ml-3 " to="/app/tickets">
                    </router-link>
              <a class="hover-info" href="javascript:;" @click="OnDetailCustomer()">{{ customerName }}</a> <span class="text-danger">شماره تیکت : {{ticketId}}#</span> </h5>
              &nbsp; &nbsp;
              <a @click="OnDetail(ticketId)"> <i class="fas fa-info text-info"></i> </a>
              <i class="fad fa-sort-alt h5 float-left ml-1 hover-warning" title="مرتب سازی پیام" @click="sortMessageChange()"></i>
           </div> -->


            <!-- مسئول -->
            <!-- <div class="imgText" v-if="!isCustomer & chatRoomId != undefined" dir="rtl">
              <div class="row pt-4">
                <div class="col-10">
                  <SearchableCombo :edit="false" :grp="0" :code="null" @ResultCombo="GetResulUserId" v-if="IsIdUser"
                    :rownumintable="3" :defaultvalue="ticketManagerTblUserId" :action="'TblCrmCombo/GetUserDatails'"
                    :method="'POST'" :idinput="'UserId'" class="mt-2" :keyItem="'UserId'"> </SearchableCombo>
                </div>

              </div>
            </div> -->
            <!-- وضعیت -->
            <!-- <div class="imgText" v-if="!isCustomer & chatRoomId != undefined" dir="rtl">
              <div class="row pt-4">
                <div class="col-10">
                  <SearchableCombo v-if="IsIdUser" :edit="false" :noIcone="true" :grp="41" :code="null"
                    @ResultCombo="GetResultGrp41" :rownumintable="3" :defaultvalue="tblComboIdTicketStatus"
                    :action="'TblCrmCombo/GetComboById'" :method="'POST'" class="mt-2" :idinput="'Grp41Id'"
                    :keyItem="'Grp41Id'">
                  </SearchableCombo>
                </div>
              </div>
            </div> -->
            <!-- نوع تیکت -->
            <!-- <div class="imgText" v-if="!isCustomer & chatRoomId != undefined" dir="rtl">
              <div class="row pt-4">
                <div class="col-10">
                  <SearchableCombo v-if="IsIdUser" :edit="false" :grp="45" :code="null" @ResultCombo="GetResultGrp45"
                    :rownumintable="3" :defaultvalue="grp45Id" :action="'TblCrmCombo/GetComboById'" :method="'POST'"
                    :idinput="'Grp45Id'" :keyItem="'Grp45Id'" class="mt-2">
                  </SearchableCombo>
                </div>
              </div>
            </div> -->

            <!-- اهمیت تیکت -->
            <!-- <div class="imgText" v-if="!isCustomer & chatRoomId != undefined" dir="rtl">
              <div class="row pt-4">
                <div class="col-10">
                  <SearchableCombo v-if="IsIdUser" :edit="false" :grp="42" :code="null" :rownumintable="3"
                    @ResultCombo="GetResultGrp42" :action="'TblCrmCombo/GetComboById'" :method="'POST'"
                    :idinput="'Grp42Id'" :keyItem="'Grp42Id'" :defaultvalue="grp42Id" :disabled="false" class="mt-2">
                  </SearchableCombo>
                </div>
              </div>
            </div> -->

            <!-- --------------------------------------------- -->
            <i class="fad fa-sort-alt h4 float-left mx-2" @click="sortMessageChange()" v-if="isCustomer"
              title="چیدمان پیام ها"></i>
            <button class="btn btn-danger px-2 mx-1 col-1 p-xl-2 p-lg-1" @click="customerCloseTicket()"
              v-if="isCustomer & tblComboIdTicketStatus != 1796">بستن تیکت</button>

            <!-- <div dir="rtl" class="w-100 row" style="margin-right: 0px" v-if="!isCustomer">
              <div class="col4">
                <router-link tag="i" class="fad fa-arrow-right h4 h100 text-secondary ml-3 mt-3" to="/app/tickets">
                </router-link>
              </div>
              <div class="col">
                <a class="hover-info" href="javascript:;" @click="OnDetailCustomer()">{{ customerName }}</a>
                <br />
                <h6 class="">
                  <h5>{{ ticketId }}</h5>
                </h6>
              </div>
            </div> -->

            <div class="imgText w-100 justify-content-start" v-if="isCustomer" dir="rtl">
              <div class="userimg">
                <img src="@/assets/SupportProfile.jpg" alt="" class="cover" />
              </div>
              <h6 class="mr-1">
                پشتیبان <br />
                <h5> شماره تیکت # {{ ticketId }}</h5>
              </h6>
            </div>

            <router-link v-if="isCustomer" tag="i" class="fad fa-arrow-right text-secondary h4 ml-3"
              to="/app/CustomerTicket">
            </router-link>
          </div>

          <div class="d-flex justify-content-center col-12 refresh-page">
            <i class="fas fa-sync-alt h5 mt-1 pointer" @click="refreshPage()" title="بروزرسانی صفحه"></i>
          </div>
          <!-- #endregion -->

          <!-- CHAT-BOX -->
          <div class="chatbox" :class="[sortMess ? ['sortMessage'] : ['']]" id="chat-Box" v-if="renderChatBox">

            <!-- #region مشاهده پیام ریپلای شده و پیام فایلی و عکس -->
            <div v-if="render">

              <div v-if="replyMessageData.id > 0" class="row p-3 reply-mess" style="margin-bottom: -10px">

                <div class="col-11 text-right m-0 text-secondary font-weight-bold">
                  <i class="fad fa-reply text-secondary ml-2"></i>

                  {{
                    replyMessageData.mess.length > 50 ? '... ' + replyMessageData.mess.slice(0, 50) :
                      replyMessageData.mess
                  }}
                  {{ replyMessageData.grp43 }}
                </div>
                <div class="col-1 text-left">
                  <i @click="cancelReply()" class="fas fa-times"></i>
                </div>
              </div>

              <div v-if="uploadImageName != ''" class="row p-3 imageName" style="margin-bottom: -10px">
                <div class="col-1 text-left">
                  <i @click="cancelUpload()" class="fas fa-times"></i>
                </div>
                <div class="col-11 text-right m-0 text-secondary font-weight-bold" style="margin: 35px">
                  {{ uploadImageName }} - {{ imageSize }} Kb &nbsp;&nbsp;&nbsp;
                  <i class="fad fa-upload text-secondary"></i>
                </div>
              </div>

            </div>
            <!-- #endregion -->

            <div v-for="(item, index) in chatMessage" :key="index" v-if="render">
              <!-- پیام ها اگر یوزر به عنوان مشتری وارد سایت شود -->
              <div v-if="$session.get('CustomerInfo') != undefined && $session.get('CustomerInfo').Id > 0 & render">
                <div>
                  <!-- نمایش پیام خود مشتری در سمت راست صفحه -->
                  <!-- حالت پیام خودکار -->
                  <div v-if="item.TblComboGrpId43 === 1806 && item.TblCustomerId > 0" class="message my_msg">
                    <p>
                      {{ item.Message }}<br /><span id="sender">{{ item.NamFam }}</span><span>{{
                        item.DateTimeInsert
                      }}</span>
                    </p>
                  </div>

                  <!-- حالت پیام متنی -->
                  <div v-else-if="item.TblComboGrpId43 === 1802 && item.TblCustomerId > 0" class="message my_msg"
                    :id="item.Id + 'mainMess'">

                    <p @dblclick="editMessage(item.Id, item.Message)">
                    <section v-for="(mes, im) in item.MessageLinks" :key="im" class="d-inline">
                      <ReplyComponent :item="item" :replyForCustomer="false" :chatMessage="chatMessage"
                        v-if="im == 0 & item.ReplyMessageId != null" />
                      <section v-if="!mes.IsLink" class="d-inline">{{ mes.Message }}</section>
                      <a :href="mes.Message" v-if="mes.IsLink" class="text-success d-inline" target="_blank">{{
                        mes.Message
                      }}</a>
                    </section>
                    <span id="sender">{{ item.NamFam }}</span><span>{{ item.DateTimeInsert }}</span>
                    </p>
                  </div>

                  <!-- پیام تصویری -->
                  <div v-else-if="item.TblComboGrpId43 === 1804 && item.TblCustomerId > 0"
                    class="message my_msg gallery row" :id="item.Id + 'mainMess'">
                    <ReplyComponent :item="item" :replyForCustomer="false" :chatMessage="chatMessage"
                      v-if="item.ReplyMessageId != null" />
                    <div class="col-8 col-xl-4">
                      <!-- <img :src="url + item.FileSrc"
                                                class="img-fluid figure-img img-thumbnail lazy" loading="lazy" alt=""> -->

                      <!-- <v-lazy-image :src="url + item.FileSrc"
                                                class="img-fluid figure-img img-thumbnail" /> -->

                      <div class="containerImg">
                        <img :src="item.src" class="imageHover img-fluid figure-img img-thumbnail image-message"
                          :id="item.Id" @click="showFullSizeImg(item.Id)" />
                        <div :class="[item.isDownload ? '' : ['overlay']]">
                          <a class="icon" title="User Profile"
                            @click="imageDownload(item.Id, url + item.FileSrc, item.TblAttachmentId)">
                            <i class="fas fa-download" v-if="!item.isDownload"></i>
                            <b-spinner v-if="item.downloading" variant="primary" label="Spinning" class="mx-2">
                            </b-spinner>
                          </a>
                        </div>
                      </div>
                      <!-- کپشن تصویر -->
                      <figcaption class="figure-caption card" @dblclick="editMessage(item.Id, item.Message)">
                        <section v-for="(mes, im) in item.MessageLinks" :key="im" class="d-inline">
                          <section v-if="!mes.IsLink" class="d-inline">{{ mes.Message }}</section>
                          <a :href="mes.Message" v-if="mes.IsLink" class="text-success d-inline" target="_blank">{{
                            mes.Message
                          }}</a>
                        </section>
                        <span id="sender">{{ item.NamFam }}</span><span>{{ item.DateTimeInsert }}</span>
                      </figcaption>
                    </div>
                  </div>

                  <!-- پیام فایلی -->
                  <div v-else-if="item.TblComboGrpId43 === 1805 && item.TblCustomerId > 0" class="message my_msg "
                    :id="item.Id + 'mainMess'">
                    <p>
                      <a @click="fileDownload(item.TblAttachmentId, item)" class="mr-3" target="_blank" download
                        title="برای دانلود کلیک کنید">
                        <i class="fas fa-download h2 text-secondary hover-info"></i>
                      </a>
                    </p>
                    <p @dblclick="editMessage(item.Id, item.Message)">
                    <section v-for="(mes, im) in item.MessageLinks" :key="im" class="d-inline">
                      <ReplyComponent :item="item" :replyForCustomer="false" :chatMessage="chatMessage"
                        v-if="im == 0 & item.ReplyMessageId != null" />
                      <section v-if="!mes.IsLink" class="d-inline">{{ mes.Message }}</section>
                      <a :href="mes.Message" v-if="mes.IsLink" class="text-success d-inline" target="_blank">{{
                        mes.Message
                      }}</a>
                    </section>
                    <span id="sender">{{ item.NamFam }}</span><span>{{ item.DateTimeInsert }}</span>
                    </p>
                  </div>
                  <!-- پایان نمایش پیام های خود مشتری در سمت راست صفحه -->

                  <!-- نمایش پیام پشتیبان سمت چپ صفحه -->
                  <!-- حالت پیام خودکار -->
                  <div v-if="item.TblComboGrpId43 === 1806 && item.TblUserId > 0" class="message friend_msg">
                    <p>
                      {{ item.Message }}<br />
                      <a :href="link" v-for="(link, i) in item.Link" :key="i" class="text-success" target="_blank"> لینک
                        {{ i + 1 }} </a><span id="sender">{{ item.NamFam }}.</span><span>{{ item.DateTimeInsert }}</span>
                    </p>
                  </div>

                  <!-- حالت پیام متنی -->
                  <div v-else-if="item.TblComboGrpId43 === 1802 && item.TblUserId > 0" class="message friend_msg"
                    :id="item.Id + 'mainMess'" @mouseenter="showIconReply(true, $event)" @mouseleave="showIconReply(false, $event)">
                    <p @dblclick="editMessage(item.Id, item.Message)">
                    <section v-for="(mes, im) in item.MessageLinks" :key="im" class="d-inline">
                      <ReplyComponent :item="item" :replyForCustomer="true" :chatMessage="chatMessage"
                        v-if="im == 0 & item.ReplyMessageId != null" />
                      <section v-if="!mes.IsLink" class="d-inline">{{ mes.Message }}</section>
                      <a :href="mes.Message" v-if="mes.IsLink" class="text-success d-inline" target="_blank">{{
                        mes.Message
                      }}</a>
                    </section>
                    <span id="sender">{{ item.NamFam }}</span><span>{{ item.DateTimeInsert }}</span>
                    <star-rating :show-rating="false" :star-size="15" :inline="true" v-model="item.score"
                      @rating-selected="scoreChangeNew(item.Id, item.score)"
                      :read-only="item.score == null ? false : true"> </star-rating>
                    </p>
                    <i class="fas Pointer fa-reply ml-1 mt-1 reply-icon d-none" @click="replyMessage(item)"
                      data-title="پاسخ به پیام"></i>
                  </div>

                  <!-- پیام تصویری -->
                  <div v-else-if="item.TblComboGrpId43 === 1804 && item.TblUserId > 0"
                    class="message friend_msg gallery row" :id="item.Id + 'mainMess'" @mouseenter="showIconReply(true, $event)" @mouseleave="showIconReply(false, $event)">
                    <ReplyComponent :item="item" :replyForCustomer="true" :chatMessage="chatMessage"
                      v-if="item.ReplyMessageId != null" />
                    <div class="col-8 col-xl-4">
                      <div class="containerImg">
                        <img :src="item.src" class="imageHover img-fluid figure-img img-thumbnail" :id="item.Id"
                          @click="showFullSizeImg(item.Id)" />
                        <div :class="[item.isDownload ? '' : ['overlay']]">
                          <a class="icon" title="User Profile"
                            @click="imageDownload(item.Id, url + item.FileSrc, item.TblAttachmentId)">
                            <i class="fas fa-download" v-if="!item.isDownload"></i>
                            <b-spinner v-if="item.downloading" variant="primary" label="Spinning" class="mx-2">
                            </b-spinner>
                          </a>
                        </div>
                      </div>

                      <figcaption class="figure-caption card bg-light" @dblclick="editMessage(item.Id, item.Message)">
                        <section v-for="(mes, im) in item.MessageLinks" :key="im" class="d-inline">
                          <section v-if="!mes.IsLink" class="d-inline">{{ mes.Message }}</section>
                          <a :href="mes.Message" v-if="mes.IsLink" class="text-success d-inline" target="_blank">{{
                            mes.Message
                          }}</a>
                        </section>
                        <span id="sender">{{ item.NamFam }}</span><span>{{ item.DateTimeInsert }}</span>
                        <div dir="rtl">
                          <star-rating :show-rating="false" :star-size="15" :inline="true" v-model="item.score"
                            @rating-selected="scoreChangeNew(item.Id, item.score)"
                            :read-only="item.score == null ? false : true"> </star-rating>
                        </div>
                      </figcaption>
                    </div>
                    <i class="fas Pointer fa-reply ml-1 mt-1 reply-icon d-none" @click="replyMessage(item)"
                      data-title="پاسخ به پیام"></i>
                  </div>

                  <!-- پیام فایلی -->
                  <div v-else-if="item.TblComboGrpId43 === 1805 && item.TblUserId > 0" class="message friend_msg"
                    :id="item.Id + 'mainMess'" @mouseenter="showIconReply(true, $event)" @mouseleave="showIconReply(false, $event)">
                    <p>
                      <a @click="fileDownload(item.TblAttachmentId, item)" class="mr-3" target="_blank" download
                        title="برای دانلود کلیک کنید">
                        <i class="fas fa-download h2 text-secondary hover-info"></i>
                      </a>
                    </p>
                    <p @dblclick="editMessage(item.Id, item.Message)">
                    <section v-for="(mes, im) in item.MessageLinks" :key="im" class="d-inline">
                      <ReplyComponent :item="item" :replyForCustomer="true" :chatMessage="chatMessage"
                        v-if="im == 0 & item.ReplyMessageId != null" />
                      <section v-if="!mes.IsLink" class="d-inline">{{ mes.Message }}</section>
                      <a :href="mes.Message" v-if="mes.IsLink" class="text-success d-inline" target="_blank">{{
                        mes.Message
                      }}</a>
                    </section>
                    <span id="sender">{{ item.NamFam }}</span><span>{{ item.DateTimeInsert }}</span>
                    <star-rating :show-rating="false" :star-size="15" :inline="true" v-model="item.score"
                      @rating-selected="scoreChangeNew(item.Id, item.score)"
                      :read-only="item.score == null ? false : true"> </star-rating>
                    </p>
                    <i class="fas Pointer fa-reply ml-1 mt-1 reply-icon d-none" @click="replyMessage(item)"
                      data-title="پاسخ به پیام"></i>
                  </div>
                </div>
              </div>

              <!-- پیام ها اگر یوزر به عنوان پشتیبان وارد سایت شود -->
              <div v-else>
                <div>
                  <!-- نمایش پیام خود پشتیبان در سمت راست صفحه -->
                  <!-- حالت پیام خودکار -->
                  <div v-if="item.TblComboGrpId43 === 1806 && item.TblUserId > 0" class="message my_msg">
                    <p>
                      {{ item.Message }}<br /><span id="sender">{{ item.NamFam }}.</span><span>{{
                        item.DateTimeInsert
                      }}</span>
                    </p>
                  </div>

                  <!-- حالت پیام متنی -->
                  <div v-if="item.TblComboGrpId43 === 1802 && item.TblUserId > 0" class="message my_msg"
                    :id="item.Id + 'mainMess'" @mouseenter="showIconRemoveMess(true, index, $event, item)"
                    @mouseleave="showIconRemoveMess(false, index, $event, item)">
                    <i v-if="item.IsView == 0" @click="removeMessage(item)"
                      class="fas fa-times hover-danger h5 mt-1 mr-1 remove-meesage d-none"></i>
                    <p v-if="item.IsView == 0" @dblclick="editMessage(item.Id, item.Message)">
                    <section v-for="(mes, im) in item.MessageLinks" :key="im" class="d-inline">
                      <ReplyComponent :item="item" :replyForCustomer="false" :chatMessage="chatMessage"
                        v-if="im == 0 & item.ReplyMessageId != null" />
                      <section v-if="!mes.IsLink" class="d-inline">{{ mes.Message }}</section>
                      <a :href="mes.Message" v-if="mes.IsLink" class="text-success d-inline" target="_blank">{{
                        mes.Message
                      }}</a>
                    </section>
                    <span id="sender">{{ item.NamFam }}</span><span>{{ item.DateTimeInsert }}</span>
                    <star-rating :show-rating="false" :star-size="15" :inline="true" v-model="item.score"
                      :read-only="true"> </star-rating>
                    </p>
                    <p v-if="item.IsView != 0">
                    <section v-for="(mes, im) in item.MessageLinks" :key="im" class="d-inline">
                      <ReplyComponent :item="item" :replyForCustomer="false" :chatMessage="chatMessage"
                        v-if="im == 0 & item.ReplyMessageId != null" />
                      <section v-if="!mes.IsLink" class="d-inline">{{ mes.Message }}</section>
                      <a :href="mes.Message" v-if="mes.IsLink" class="text-success d-inline" target="_blank">{{
                        mes.Message
                      }}</a>
                    </section>
                    <span id="sender">{{ item.NamFam }}</span><span>{{ item.DateTimeInsert }}</span>
                    <star-rating :show-rating="false" :star-size="15" :inline="true" v-model="item.score"
                      :read-only="true"> </star-rating>
                    </p>
                  </div>

                  <!-- حالت پیام یادداشت -->
                  <div v-else-if="item.TblComboGrpId43 === 1803 && item.TblUserId > 0" class="message my_msg"
                    @mouseenter="showIconRemoveMess(true, index, $event, item)"
                    @mouseleave="showIconRemoveMess(false, index, $event, item)">
                    <i v-if="item.IsView == 0" @click="removeMessage(item)"
                      class="fas fa-times hover-danger h5 mt-1 mr-1 remove-meesage d-none"></i>
                    <p class="note" @dblclick="editMessage(item.Id, item.Message)" v-if="item.IsView == 0">
                    <section v-for="(mes, im) in item.MessageLinks" :key="im" class="d-inline">
                      <ReplyComponent :item="item" :replyForCustomer="false" :chatMessage="chatMessage"
                        v-if="im == 0 & item.ReplyMessageId != null" />
                      <section v-if="!mes.IsLink" class="d-inline">{{ mes.Message }}</section>
                      <a :href="mes.Message" v-if="mes.IsLink" class="text-success d-inline" target="_blank">{{
                        mes.Message
                      }}</a>
                    </section>
                    <span id="sender">{{ item.NamFam }}</span><span>{{ item.DateTimeInsert }}</span>
                    </p>
                    <p class="note" v-else>
                    <section v-for="(mes, im) in item.MessageLinks" :key="im" class="d-inline">
                      <ReplyComponent :item="item" :replyForCustomer="false" :chatMessage="chatMessage"
                        v-if="im == 0 & item.ReplyMessageId != null" />
                      <section v-if="!mes.IsLink" class="d-inline">{{ mes.Message }}</section>
                      <a :href="mes.Message" v-if="mes.IsLink" class="text-success d-inline" target="_blank">{{
                        mes.Message
                      }}</a>
                    </section>
                    <span id="sender">{{ item.NamFam }}</span><span>{{ item.DateTimeInsert }}</span>
                    </p>
                  </div>

                  <!-- پیام یادداشت تصویری -->
                  <div v-else-if="item.TblComboGrpId43 === 2500 && item.TblUserId > 0" class="message my_msg gallery"
                    @mouseenter="showIconRemoveMess(true, index, $event, item)"
                    @mouseleave="showIconRemoveMess(false, index, $event, item)">

                    <ReplyComponent :item="item" :replyForCustomer="false" :chatMessage="chatMessage"
                      v-if="item.ReplyMessageId != null" />

                    <i v-if="item.IsView == 0" @click="removeMessage(item)"
                      class="fas fa-times hover-danger h5 mt-1 mr-1 remove-meesage d-none"></i>

                    <div class="col-8 col-xl-4">

                      <div class="containerImg">

                        <img :src="item.src" class="imageHover img-fluid figure-img img-thumbnail" :id="item.Id"
                          @click="showFullSizeImg(item.Id)" />

                        <div :class="[item.isDownload ? '' : ['overlay']]">
                          <a class="icon" title="User Profile"
                            @click="imageDownload(item.Id, url + item.FileSrc, item.TblAttachmentId)">
                            <i class="fas fa-download" v-if="!item.isDownload"></i>
                            <b-spinner v-if="item.downloading" variant="primary" label="Spinning" class="mx-2">
                            </b-spinner>
                          </a>
                        </div>

                      </div>

                      <figcaption class="figure-caption card note" @dblclick="editMessage(item.Id, item.Message)"
                        v-if="item.IsView == 0">
                        <section v-for="(mes, im) in item.MessageLinks" :key="im" class="d-inline">
                          <section v-if="!mes.IsLink" class="d-inline">{{ mes.Message }}</section>
                          <a :href="mes.Message" v-if="mes.IsLink" class="text-success d-inline" target="_blank">{{
                            mes.Message
                          }}</a>
                        </section>
                        <span>{{ item.DateTimeInsert }}</span><span id="sender">{{ item.NamFam }}</span>
                      </figcaption>

                      <figcaption class="figure-caption card note" v-else>
                        <section v-for="(mes, im) in item.MessageLinks" :key="im" class="d-inline">
                          <section v-if="!mes.IsLink" class="d-inline">{{ mes.Message }}</section>
                          <a :href="mes.Message" v-if="mes.IsLink" class="text-success d-inline" target="_blank">{{
                            mes.Message
                          }}</a>
                        </section>
                        <span>{{ item.DateTimeInsert }}</span><span id="sender">{{ item.NamFam }}</span>
                      </figcaption>

                    </div>
                  </div>


                  <!-- یادداشت فایلی -->
                  <div v-else-if="item.TblComboGrpId43 === 2501 && item.TblUserId > 0" class="message my_msg"
                    @mouseenter="showIconRemoveMess(true, index, $event, item)"
                    @mouseleave="showIconRemoveMess(false, index, $event, item)">
                    <i v-if="item.IsView == 0" @click="removeMessage(item)"
                      class="fas fa-times hover-danger h5 mt-1 mr-1 remove-meesage d-none"></i>
                    <p class="note">
                      <a class="mr-3" target="_blank" download title="برای دانلود کلیک کنید"
                        @click="fileDownload(item.TblAttachmentId, item)">
                        <i class="fas fa-download h2 text-secondary hover-info"></i>
                      </a>
                    </p>
                    <p @dblclick="editMessage(item.Id, item.Message)" class="note" v-if="item.IsView == 0">
                    <section v-for="(mes, im) in item.MessageLinks" :key="im" class="d-inline">
                      <ReplyComponent :item="item" :replyForCustomer="false" :chatMessage="chatMessage"
                        v-if="im == 0 & item.ReplyMessageId != null" />
                      <section v-if="!mes.IsLink" class="d-inline">{{ mes.Message }}</section>
                      <a :href="mes.Message" v-if="mes.IsLink" class="text-success d-inline" target="_blank">{{
                        mes.Message
                      }}</a>
                    </section>
                    <span id="sender">{{ item.NamFam }}</span><span>{{ item.DateTimeInsert }}</span>
                    </p>
                    <p class="note" v-else>
                    <section v-for="(mes, im) in item.MessageLinks" :key="im" class="d-inline">
                      <ReplyComponent :item="item" :replyForCustomer="false" :chatMessage="chatMessage"
                        v-if="im == 0 & item.ReplyMessageId != null" />
                      <section v-if="!mes.IsLink" class="d-inline">{{ mes.Message }}</section>
                      <a :href="mes.Message" v-if="mes.IsLink" class="text-success d-inline" target="_blank">{{
                        mes.Message
                      }}</a>
                    </section>
                    <span id="sender">{{ item.NamFam }}</span><span>{{ item.DateTimeInsert }}</span>
                    </p>
                  </div>


                  <!-- پیام تصویری -->
                  <div v-else-if="item.TblComboGrpId43 === 1804 && item.TblUserId > 0"
                    class="message my_msg gallery row" @mouseenter="showIconRemoveMess(true, index, $event, item)"
                    @mouseleave="showIconRemoveMess(false, index, $event, item)" :id="item.Id + 'mainMess'">

                    <ReplyComponent :item="item" :replyForCustomer="false" :chatMessage="chatMessage"
                      v-if="item.ReplyMessageId != null" />

                    <i v-if="item.IsView == 0" @click="removeMessage(item)"
                      class="fas fa-times hover-danger h5 mt-1 mr-1 remove-meesage d-none"></i>

                    <div class="col-8 col-xl-4">

                      <div class="containerImg">

                        <img :src="item.src" class="imageHover img-fluid figure-img img-thumbnail" :id="item.Id"
                          @click="showFullSizeImg(item.Id)" />

                        <div :class="[item.isDownload ? '' : ['overlay']]">
                          <a class="icon" title="User Profile"
                            @click="imageDownload(item.Id, url + item.FileSrc, item.TblAttachmentId)">
                            <i class="fas fa-download" v-if="!item.isDownload"></i>
                            <b-spinner v-if="item.downloading" variant="primary" label="Spinning" class="mx-2">
                            </b-spinner>
                          </a>

                        </div>

                      </div>

                      <figcaption class="figure-caption card" v-if="item.IsView == 0"
                        @dblclick="editMessage(item.Id, item.Message)">
                        <section v-for="(mes, im) in item.MessageLinks" :key="im" class="d-inline">
                          <section v-if="!mes.IsLink" class="d-inline">{{ mes.Message }}</section>
                          <a :href="mes.Message" v-if="mes.IsLink" class="text-success d-inline" target="_blank">{{
                            mes.Message
                          }}</a>
                        </section>
                        <span>{{ item.DateTimeInsert }}</span><span id="sender">{{ item.NamFam }}</span>
                        <div dir="rtl">
                          <star-rating :show-rating="false" :star-size="15" :inline="true" v-model="item.score"
                            :read-only="true"> </star-rating>
                        </div>
                      </figcaption>

                      <figcaption class="figure-caption card" v-else>
                        <section v-for="(mes, im) in item.MessageLinks" :key="im" class="d-inline">
                          <section v-if="!mes.IsLink" class="d-inline">{{ mes.Message }}</section>
                          <a :href="mes.Message" v-if="mes.IsLink" class="text-success d-inline" target="_blank">{{
                            mes.Message
                          }}</a>
                        </section>
                        <span>{{ item.DateTimeInsert }}</span><span id="sender">{{ item.NamFam }}</span>
                        <div dir="rtl">
                          <star-rating :show-rating="false" :star-size="15" :inline="true" v-model="item.score"
                            :read-only="true"> </star-rating>
                        </div>
                      </figcaption>

                    </div>
                  </div>

                  <!-- پیام فایلی -->
                  <div v-else-if="item.TblComboGrpId43 === 1805 && item.TblUserId > 0" class="message my_msg"
                    @mouseenter="showIconRemoveMess(true, index, $event, item)"
                    @mouseleave="showIconRemoveMess(false, index, $event, item)" :id="item.Id + 'mainMess'">
                    <i v-if="item.IsView == 0" @click="removeMessage(item)"
                      class="fas fa-times hover-danger h5 mt-1 mr-1 remove-meesage d-none"></i>
                    <p>
                      <a class="mr-3" target="_blank" download title="برای دانلود کلیک کنید"
                        @click="fileDownload(item.TblAttachmentId, item)">
                        <i class="fas fa-download h2 text-secondary hover-info"></i>
                      </a>
                    </p>
                    <p @dblclick="editMessage(item.Id, item.Message)" v-if="item.IsView == 0">
                    <section v-for="(mes, im) in item.MessageLinks" :key="im" class="d-inline">
                      <ReplyComponent :item="item" :replyForCustomer="false" :chatMessage="chatMessage"
                        v-if="im == 0 & item.ReplyMessageId != null" />
                      <section v-if="!mes.IsLink" class="d-inline">{{ mes.Message }}</section>
                      <a :href="mes.Message" v-if="mes.IsLink" class="text-success d-inline" target="_blank">{{
                        mes.Message
                      }}</a>
                    </section>
                    <span id="sender">{{ item.NamFam }}</span><span>{{ item.DateTimeInsert }}</span>
                    <star-rating :show-rating="false" :star-size="15" :inline="true" v-model="item.score"
                      :read-only="true"> </star-rating>
                    </p>
                    <p v-else>
                    <section v-for="(mes, im) in item.MessageLinks" :key="im" class="d-inline">
                      <ReplyComponent :item="item" :replyForCustomer="false" :chatMessage="chatMessage"
                        v-if="im == 0 & item.ReplyMessageId != null" />
                      <section v-if="!mes.IsLink" class="d-inline">{{ mes.Message }}</section>
                      <a :href="mes.Message" v-if="mes.IsLink" class="text-success d-inline" target="_blank">{{
                        mes.Message
                      }}</a>
                    </section>
                    <span id="sender">{{ item.NamFam }}</span><span>{{ item.DateTimeInsert }}</span>
                    <star-rating :show-rating="false" :star-size="15" :inline="true" v-model="item.score"
                      :read-only="true"> </star-rating>
                    </p>
                  </div>


                  <!-- نمایش پیام مشتری سمت چپ صفحه -->
                  <!-- حالت پیام متنی -->
                  <div v-else-if="item.TblComboGrpId43 === 1802 && item.TblCustomerId > 0" class="message friend_msg"
                    id="testIneer" :id="item.Id + 'mainMess'" @mouseenter="showIconReply(true, $event)" @mouseleave="showIconReply(false, $event)">
                    <p>
                    <section v-for="(mes, im) in item.MessageLinks" :key="im" class="d-inline">
                      <ReplyComponent :item="item" :replyForCustomer="true" :chatMessage="chatMessage"
                        v-if="im == 0 & item.ReplyMessageId != null" />
                      <section v-if="!mes.IsLink" class="d-inline">{{ mes.Message }}</section>
                      <a :href="mes.Message" v-if="mes.IsLink" class="text-success d-inline" target="_blank">{{
                        mes.Message
                      }}</a>
                    </section>
                    <span id="sender">{{ item.NamFam }}</span><span>{{ item.DateTimeInsert }}
                    </span>
                    </p>
                    <i class="fas Pointer fa-reply ml-1 mt-1 reply-icon d-none" @click="replyMessage(item)"
                      data-title="پاسخ به پیام"></i>
                  </div>

                  <!-- پیام تصویری -->
                  <div v-else-if="item.TblComboGrpId43 === 1804 && item.TblCustomerId > 0"
                    class="message friend_msg gallery row" :id="item.Id + 'mainMess'" @mouseenter="showIconReply(true, $event)" @mouseleave="showIconReply(false, $event)">
                    <ReplyComponent :item="item" :replyForCustomer="true" :chatMessage="chatMessage"
                      v-if="item.ReplyMessageId != null" />

                    <div class="col-8 col-xl-4">
                      <div class="containerImg">
                        <img :src="item.src" class="imageHover img-fluid figure-img img-thumbnail" :id="item.Id"
                          @click="showFullSizeImg(item.Id)" />
                        <div :class="[item.isDownload ? '' : ['overlay']]">
                          <a class="icon" title="User Profile"
                            @click="imageDownload(item.Id, url + item.FileSrc, item.TblAttachmentId)">
                            <i class="fas fa-download" v-if="!item.isDownload"></i>
                            <b-spinner v-if="item.downloading" variant="primary" label="Spinning" class="mx-2">
                            </b-spinner>
                          </a>
                        </div>
                      </div>

                      <figcaption class="figure-caption card bg-light">
                        <section v-for="(mes, im) in item.MessageLinks" :key="im" class="d-inline">
                          <section v-if="!mes.IsLink" class="d-inline">{{ mes.Message }}</section>
                          <a :href="mes.Message" v-if="mes.IsLink" class="text-success d-inline" target="_blank">{{
                            mes.Message
                          }}</a>
                        </section>
                        <span>{{ item.DateTimeInsert }}</span><span id="sender">{{ item.NamFam }}</span>
                      </figcaption>
                    </div>
                    <i class="fas Pointer fa-reply ml-1 mt-1 reply-icon d-none" @click="replyMessage(item)"
                      data-title="پاسخ به پیام"></i>
                  </div>

                  <!-- پیام فایلی -->
                  <div v-else-if="item.TblComboGrpId43 === 1805 && item.TblCustomerId > 0" class="message friend_msg"
                    :id="item.Id + 'mainMess'" @mouseenter="showIconReply(true, $event)" @mouseleave="showIconReply(false, $event)">
                    <p>
                      <a @click="fileDownload(item.TblAttachmentId, item)" class="mr-3" target="_blank" download
                        title="برای دانلود کلیک کنید">
                        <i class="fas fa-download h2 text-secondary hover-info"></i>
                      </a>
                    </p>
                    <p>
                    <section v-for="(mes, im) in item.MessageLinks" :key="im" class="d-inline">
                      <ReplyComponent :item="item" :replyForCustomer="true" :chatMessage="chatMessage"
                        v-if="im == 0 & item.ReplyMessageId != null" />
                      <section v-if="!mes.IsLink" class="d-inline">{{ mes.Message }}</section>
                      <a :href="mes.Message" v-if="mes.IsLink" class="text-success d-inline" target="_blank">{{
                        mes.Message
                      }}</a>
                    </section>
                    <span id="sender">{{ item.NamFam }}</span><span>{{ item.DateTimeInsert }}</span>
                    </p>
                    <i class="fas Pointer fa-reply ml-1 mt-1 reply-icon d-none" @click="replyMessage(item)"
                      data-title="پاسخ به پیام"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- CHAT INPUT -->
          <div class="chat_input" dir="rtl" v-if="tblComboIdTicketStatus != 1842">

            <h4 class="mx-2">
              <label for="inputImage">
                <a class="badge">
                  <i class="fad fa-paperclip hover-info h5" title="ارسال عکس"></i>
                </a>
                <input type="file" id="inputImage" style="display: none" name="image" :accept="acceptFile" multiple=""
                  data-original-title="upload photos" @change="uploadImage()" />
              </label>
            </h4>

            <textarea class="h-75 form-control w-100" v-model="newMessage" rows="6"
              @keyup.enter="sendMessage(1802, true, $event)" ref="newMessage"
              placeholder="ارسال پیام shift + enter"> </textarea>

            <b-spinner v-if="isSendingMesssage" variant="primary" label="Spinning" class="mx-2"></b-spinner>

            <div class="d-flex" v-if="chatRoomId != undefined">
              <i class="fa-duotone fa-paper-plane-top fa-rotate-180 hover-info h4 mx-2 mb-1 text-secondary"
                title="ارسال پیام" v-if="!showEditMessage & !isSendingMesssage" @click="sendMessage(1802)"
                @keyup.enter="sendMessage(1802)"></i>

              <i class="fad fa-comment-alt-lines mx-2 hover-danger text-secondary h4"
                v-if="!showEditMessage & !isCustomer & !isSendingMesssage" title="ارسال به عنوان یادداشت"
                @click="sendMessage(1803)"></i>

              <i class="fad fa-search-plus hover-info h4 mx-2 text-secondary" title="ارسال پیام"
                v-if="!showEditMessage & !isSendingMesssage" @click="showMoadalInput()"></i>

              <i class="fas fa-pencil mx-2 hover-info h4 mx-2 text-secondary" title="پاسخ های آماده"
                @click="showMoadalReadyAnswers()" v-if="!showEditMessage & !isCustomer & !isSendingMesssage"></i>

              <i class="fad fa-edit ml-4 hover-info h4 mx-2 text-secondary" title="ویرایش پیام" @click="changeMessage()"
                v-if="showEditMessage & !isSendingMesssage"></i>

              <i class="fad fa-times hover-danger h4 mx-2 text-secondary" title="لغو ویرایش"
                v-if="showEditMessage & !isSendingMesssage" @click="cancelEdit()"></i>

            </div>
          </div>

          <div class="chat_input justify-content-center" dir="rtl" v-else>
            <div>
              <h4>
                تیکت بایگانی شده است
              </h4>
            </div>
          </div>

        </div>
        <!-- #endregion -->
      </div>
    </div>

    <!-- #region Modals -->
    <!---Modal Ready Answers-->
    <b-modal size="lg" centered id="modal-ReadyAnswers" ref="modal">
      <template #modal-header="{ close }">
        <b-button class="bg-danger" @click="close()">
          <h4 aria-hidden="true" class="px-2">&times;</h4>
        </b-button>
        <h5>پاسخ های آماده</h5>
      </template>

      <template #default>
        <button class="btn float-left" @click="backToCatsPage" v-if="!isCatsPage">بازگشت</button>
        <BnpGrid Selectable :action="false" :propsRows="propsRows" :propsColumn="propsColumn" :NoRowNum="true"
          v-if="$store.state.renderComponentGrid" dir="rtl">
          <template slot="Name" slot-scope="props">
            <a @click="getReply(props.props)" class="text-primary">{{ props.props.Name }}</a>
          </template>

          <template slot="Reply" slot-scope="props">
            <a @click="
  newMessage += props.props.Reply;
closeMoadalReadyAnswers();
            " class="text-primary" :data-title="props.props.Reply">
              {{ props.props.Reply.slice(0, 70) + (props.props.Reply.length > 70 ? "..." : "") }}</a>
          </template>
        </BnpGrid>
      </template>

      <template #modal-footer>
        <div class="row w-100 justify-content-start"></div>
      </template>
    </b-modal>
    <!---End Modal Ready Answers-->

    <!---Modal-->
    <b-modal size="xl" centered id="modal-GnerateCode" ref="modal">
      <template #modal-header="{ close }">
        <b-button class="bg-danger" @click="close()">
          <h4 aria-hidden="true" class="px-2">&times;</h4>
        </b-button>
        <h5>متن پیام</h5>
      </template>

      <template #default>
        <div dir="rtl">
          <textarea class="h-75 form-control w-100 p-2" v-model="newMessage" rows="10" style="font-size: 18px"
            @keyup.enter="sendMessage(1802, true, $event)"></textarea>
        </div>
      </template>
      <template #modal-footer>
        <div class="row w-100 justify-content-start">
          <i class="fas fa-pencil mx-2 hover-info h4 text-secondary mt-1" title="پاسخ های آماده"
            @click="showMoadalReadyAnswers()" v-if="!showEditMessage & !isCustomer"></i>

          <i class="fad fa-comment-alt-lines hover-danger text-secondary h4 mx-2 mt-1"
            v-if="!showEditMessage & !isCustomer" title="ارسال به عنوان یادداشت" @click="sendMessage(1803)"></i>

          <i class="fa-duotone fa-paper-plane-top fa-rotate-180 hover-info h4 mx-2 text-secondary mb-2"
            title="ارسال پیام" v-if="!showEditMessage" @click="sendMessage(1802)" @keyup.enter="sendMessage(1802)"></i>
        </div>
      </template>
    </b-modal>
    <!---Modal-->

    <!---Modal Change Dep-->
    <Modal v-if="showModalRefrence" :InheritanceTheme="true" :size="'md-header'" :noHeader="true" :zIndex="true">
      <template v-slot:headerMd>
        <div class="justify-content-start col-12">
          <h4 class="d-inline mr-3">تغییر دپارتمان تیکت</h4>
        </div>
        <span class="fas fa-times Pointer" @click="showModalRefrence = false; modalTicketStatus = false"></span>
      </template>
      <template v-slot:body>
        <div class="row p-3 justify-content-center">

          {{ checkRefrenceTicketResult.messsage }}

          <div class="col-12 text-right mt-5">
            <small>انتخاب دپارتمان</small>
            <select class="form-control col-12 mt-2 Pointer" id="changeDepSelectList">
              <option v-for="depart in checkRefrenceTicketResult.userDepartments" :key="depart.departmentId"
                :value="depart.departmentId">{{ depart.departmentName }}</option>
            </select>
            <div class="d-flex justify-content-center mt-3">
              <button class="btn btn-success mt-3 px-5 py-2" @click="ChangeDepartment()">اعمـــال تغییرات
                دپارتمان</button>
            </div>
          </div>
        </div>
      </template>
    </Modal>

    <ModalOmid v-if="$store.state.Modal" :InheritanceTheme="true" :IsFooter="false" :Size="'Md'">
      <template v-slot:headerMd>
        <div class="justify-content-start col-12">
          <h4 class="d-inline mr-3">گردش کار</h4>
        </div>
      </template>
      <template v-slot:body>
        <div dir="rtl">
          <BnpGrid v-if="$store.state.renderComponentGridModal" :propsColumn="ColumnRiz" :propsRows="rows"
            :hasRowNum="true" :Selectable="false"></BnpGrid>
        </div>
      </template>
    </ModalOmid>

    <Modal v-if="modalTicketStatus" :InheritanceTheme="true" :size="'md-header'" :noHeader="true">
      <template v-slot:headerMd>
        <div class="justify-content-start col-12">
          <h4 class="d-inline mr-3 text-info">#{{ ticketId }}</h4>
        </div>
        <span class="fas fa-times Pointer" @click="modalTicketStatus = false"></span>
      </template>
      <template v-slot:body>
        <div class="row justify-content-center Content" >

          <!-- مسئول تیکت -->
          <div class="col-md-6 col-12">
            <small>مسئول</small>
            <div class="px-1">
              <SearchableCombo :edit="false" :grp="0" :code="null" @ResultCombo="GetResulUserId" :rownumintable="3"
                :defaultvalue="ticketManagerTblUserId" :action="'TblCrmCombo/GetUserDatails'" :method="'POST'"
                :idinput="'UserId'" :keyItem="'UserId'"></SearchableCombo>
            </div>
          </div>

          <!-- دپارتمان تیکت -->
          <div class="col-md-6 col-12">
            <small>دپارتمان تیکت</small>
            <select class="form-control px-1" id="selectedDepartment">
              <option v-for="(dep, index) in departmentUserOption" :value="dep.departmentId" :index="index"
                :selected="dep.departmentId == departmentId ? 'selected' : ''">{{ dep.departmentName }}</option>
            </select>
          </div>

          <!-- وضعیت تیکت -->
          <div class="col-md-6 col-12">
            <small>وضعیت</small>
            <div class="px-1">
              <SearchableCombo :edit="false" :noIcone="true" :grp="41" :code="null" @ResultCombo="GetResultGrp41"
                :rownumintable="3" :defaultvalue="tblComboIdTicketStatus" :action="'TblCrmCombo/GetComboById'"
                :method="'POST'" :idinput="'Grp41Id'" :keyItem="'Grp41Id'">
              </SearchableCombo>
            </div>
          </div>

          <!-- نوع تیکت -->
          <div class="col-md-6 col-12">
            <small>نوع تیکت</small>
            <div class="px-1">
              <SearchableCombo :edit="false" :grp="45" :code="null" @ResultCombo="GetResultGrp45" :rownumintable="3"
                :defaultvalue="grp45Id" :action="'TblCrmCombo/GetComboById'" :method="'POST'" :idinput="'Grp45Id'"
                :keyItem="'Grp45Id'">
              </SearchableCombo>
            </div>
          </div>

          <!-- اهمیت تیکت -->
          <div class="col-md-6 col-12">
            <small>اهمیت تیکت</small>
            <div class="px-1">
              <SearchableCombo :edit="false" :grp="42" :code="null" :rownumintable="3" @ResultCombo="GetResultGrp42"
                :action="'TblCrmCombo/GetComboById'" :method="'POST'" :idinput="'Grp42Id'" :keyItem="'Grp42Id'"
                :defaultvalue="grp42Id" :disabled="false">
              </SearchableCombo>
            </div>
          </div>

          <div class="col-md-6 col-12">
            <button @click="submitTicketStatus()" class="btn btn-success mt-4 ml-3 w-100"
              style="height: 35px !important;">
              ثبت
            </button>
          </div>

        </div>
      </template>
    </Modal>
    <!-- #endregion -->


  </div>
</template>

<script>
import BnpGrid from "@/components/BnpGrid/BnpGrid.vue";
import SearchableCombo from "@/components/Combo/SearchableCombo.vue";
import Card from "@/components/Card/Card.vue";
import { createAvatar } from "@dicebear/avatars";
import * as style from "@dicebear/avatars-identicon-sprites";
import VLazyImage from "v-lazy-image";
import JSZip from "jszip";
import Modal from '@/pages/BnpCrm/WorkTips/WorkTipsComment.vue'
import { createNamespacedHelpers } from "vuex";
import ModalOmid from '../../Modal/Modal.vue'
import ReplyComponent from './SupportComponent/ReplyComponent.vue'
const { mapState, mapActions } = createNamespacedHelpers("layout");

export default {
  components: {
    Card,
    BnpGrid,
    SearchableCombo,
    VLazyImage,
    Modal,
    ModalOmid,
    ReplyComponent
  },
  data() {
    return {
      signalRChatConnection: null,
      signalRTicketConnection: null,
      fullPage: null,
      isCatsPage: true,
      propsRows: [],
      propsColumn: [{ name: "Name", label: "نام", visibility: true }],
      acceptFile: ['.jpg', '.gif', '.jpeg', '.png', '.pdf', '.bmp', '.txt', '.zip', '.rar', '.xls', 'csv', '.xlsx', '.doc', '.docx'],
      remotAccess: null,
      isSwitch: false,
      CustomerLogo: null,
      IsIdUser: true,
      DataAxios: {},
      chatMessage: [],
      newMessage: "",
      chatRoomId: this.$route.params.chatRoomId,
      ticketManagerTblUserId: this.$route.params.ticketManagerTblUserId,
      ticketId: this.$route.params.ticketId,
      tblComboIdTicketStatus: this.$route.params.tblComboIdTicketStatus,
      customerName: this.$route.params.customerName,
      departmentId: this.$route.params.departmentId,
      customerCode: this.$route.params.customerCode,
      ticket: this.$route.params.ticket != undefined ? this.$route.params.ticket : [],
      grp45Id: this.$route.params.tblComboGrpId45,
      grp42Id: this.$route.params.tblComboGrpId42,
      CId: this.$route.params.tblCustomerId,
      tblCombogrp37AxarinVazeit: this.$route.params.tblCombogrp37AxarinVazeit,
      DataaxiosDepUser: {
        Action: "ChatRoom/GetChatRoomMessage",
        Method: "Post",
        ArryfildValue: {
          ChatRoomId: this.$route.params.chatRoomId,
          IsCustomer: this.$session.get("CustomerInfo") != undefined && this.$session.get("CustomerInfo").Id > 0 ? true : false,
        },
      },
      render: true,
      userId: this.$session.get("UserInfo").tblUserId,
      tblUserGrpIdInsert: this.$session.get("UserInfo").tblUserGrpId,
      base64: null,
      connectionIdChat: null,
      connectionId: null,
      usersByDepartment: [],
      uploadImageName: "",
      imageSize: 0,
      fileFormat: "",
      isImage: null,
      url: this.$cookies.get("URL"),
      ticketStatus: [],
      showEditMessage: false,
      messageIdForEdit: null,
      counter: 0,
      counter2: 0,
      isCustomer: this.$session.get("CustomerInfo") != undefined && this.$session.get("CustomerInfo").Id > 0 ? true : false,
      showLeftSide: true,
      nameFam: this.$session.get("UserInfo").namFam,
      myTickets: [],
      isSendingMesssage: false,
      manualStopHub: false,
      ticketHubConnected: false,
      chattHubConnected: false,
      chatHubInterval: null,
      ticketInterval: null,
      myTicketPage: 0,
      DeaprtmentTicket: [],
      JoinDeaprtmentTicketGroup: false,
      pageInationDepTickets: {
        page: 1,
        totalPage: 0,
        pageSize: 10
      },
      pageInationMyTickets: {
        page: 1,
        totalPage: 0,
        pageSize: 10
      },
      pageInationFiltredTickets: {
        page: 1,
        totalPage: 0,
        pageSize: 10
      },
      notifMyTicket: '',
      notifDepTicket: '',
      checkRefrenceTicketResult: {},
      showModalRefrence: false,
      changeDepartmentRequest: {},
      sortMess: this.$cookies.get('sortMessage') == 'true' ? true : false,
      ColumnRiz: [
        { name: 'LogDate', label: 'تاریخ', visibility: true },
        { name: 'Action', label: 'عملیات', visibility: true },
      ],
      rows: [],
      modalTicketStatus: false,
      submitTicketStatusRequest: {},
      departmentUser: [],
      departmentUserOption: [],
      onlineUserChatRoom: [],
      replyMessageData: {
        id: 0,
        mess: '',
        isFile: false
      },
      renderChatBox: true,
      filterdTickets: [],
      tickeCp_Filter: {},
    };
  },
  beforeCreate() {
    var chatRoomId = this.$route.params.chatRoomId;
    var ticketId = this.$route.params.ticketId;
    var isCustomer = this.$session.get("CustomerInfo") != undefined && this.$session.get("CustomerInfo").Id > 0 ? true : false;
    if (ticketId === undefined) {
      if (isCustomer) {
        this.$router.push({
          name: "CustomerTicket",
        });
      }
    }
  },
  beforeDestroy() {
    // this.signalRChatConnection.invoke('UserRemoveChatRoom', this.connectionIdChat, String(this.chatRoomId), null)
    // this.signalRTicketConnection.invoke('RemoveFromGroup', this.connectionId, String(this.userId))
    // this.signalRTicketConnection.invoke('UserRemoveChatRoom', this.connectionId, String(this.chatRoomId))

    if (!this.isCustomer) {
      this.leftChatRoomOnline_Invoke().then(() => {
        this.manualStopHub = true;
        this.signalRChatConnection.stop().then(() => {
          this.manualStopHub = true;
          clearInterval(this.chatHubInterval);
        });

        this.signalRTicketConnection.stop().then(() => {
          this.manualStopHub = true;
          clearInterval(this.ticketInterval);
        });
      }).catch((err) => {
        console.error("CATCH", error);
      })
    } else {
      this.manualStopHub = true;
      this.signalRChatConnection.stop().then(() => {
        this.manualStopHub = true;
        clearInterval(this.chatHubInterval);
      });

      this.signalRTicketConnection.stop().then(() => {
        this.manualStopHub = true;
        clearInterval(this.ticketInterval);
      });
    }

    this.setCookieLastMess()
    this.saveIdLastTicket()

  },
  created() {
    if (this.collapseSlideBarChatRoom != null) {
      this.showLeftSide = this.collapseSlideBarChatRoom;
    }
    this.grp45Id = this.ticekt == undefined ? this.$route.params.tblComboGrpId45 : this.ticket.TblComboGrpId45
    this.grp42Id = this.ticekt == undefined ? this.$route.params.tblComboGrpId42 : this.ticket.TblComboGrpId42

    document.addEventListener("keydown", (event) => {
      if (event.keyCode == 70 && event.shiftKey) {
        this.showMoadalInput();
      }

      if (event.keyCode == 82 && event.shiftKey && !this.isCustomer) {
        this.showMoadalReadyAnswers();
      }
    });
    // let self = this
    // this.$nextTick()
    //     .then(function () {
    //         self.$refs.newMessage.focus()
    //     })

    this.getTicketInfo().then(()=>{
      this.chatHub();
      this.myTicket();
      this.ticketHub();
    })
    this.getTicketStatus();
    this.getCats();
  },
  mounted() {
    this.getLastTicektId_cookie()
    this.$GetAccessUser();
    this.getDepartmentUser()
    this.getCookieLastMess()
    this.initializeFilteredTicket()
  },
  computed: {
    ...mapState(["collapseSlideBarChatRoom"]),
  },
  methods: {
    ...mapActions(["setcollapseSlideBarChatRoom"]),

    previousPageFiltredTickets() {
      var page = this.pageInationFiltredTickets.page
      var totalPage = this.pageInationFiltredTickets.totalPage
      page--
      if (page > 0) {
        this.pageInationFiltredTickets.page--
        this.initializeFilteredTicket()
      }
    },

    nextPageFiltredTickets() {
      var page = this.pageInationFiltredTickets.page
      var totalPage = this.pageInationFiltredTickets.totalPage
      page++
      if (page <= totalPage) {
        this.pageInationFiltredTickets.page++
        this.initializeFilteredTicket()
      }
    },

    signalr_changeStatus(ticketId, status, tblComboIdTicketStatus) {
      let tickId = parseInt(ticketId);
      let combo41 = parseInt(tblComboIdTicketStatus)

      let ticket = this.myTickets.find(x => x.Id == tickId)
      if (ticket != undefined) {
        ticket.TblComboGrpId41 = combo41
        ticket.NameGrp41 = status
      }

      if (ticketId == this.ticketId) {
        this.tblComboIdTicketStatus = tblComboIdTicketStatus
      }

      let ticketDep = this.DeaprtmentTicket.find(x => x.Id == tickId)
      if (ticketDep != undefined) {
        ticketDep.TblComboGrpId41 = combo41
        ticketDep.NameGrp41 = status
      }
      let filtreTicket = this.filterdTickets.find(x => x.Id == tickId)
      if (this.myTicketPage == 0) {
        if (this.check_tickeCp_Filter(combo41, 'grp41')) {
          if(filtreTicket != undefined ){
            filtreTicket.TblComboGrpId41 = combo41
            filtreTicket.NameGrp41 = status
          }else{
            this.refreshTickets()
          }
        }else{
          if(filtreTicket != undefined ){
            let index = this.filterdTickets.indexOf(filtreTicket)
            this.filterdTickets.splice(index, 1)
          }
        }
      }

      this.render = false
      this.$nextTick(() => {
        this.render = true
      })

      this.IsIdUser = false
      this.$nextTick(() => {
        this.IsIdUser = true
      })
    },

    check_tickeCp_Filter(id, data) {
      if (data == 'grp41') {
        if (this.tickeCp_Filter.ListGrp41.filter(x => x == id).length > 0) {
          return true
        } else {
          return false
        }
      }
      else if (data == 'dep') {
        if (this.tickeCp_Filter.ListDepId.filter(x => x == id).length > 0) {
          return true
        } else {
          return false
        }
      }
      else if (data == 'user') {
        if(this.tickeCp_Filter.ListUsers.length == 0){
          return true
        }
        if (this.tickeCp_Filter.ListUsers.filter(x => x == id).length > 0) {
          return true
        } else {
          return false
        }
      }
    },

    initializeFilteredTicket() {
      if (!this.isCustomer) {
        let store = this.$store.state.TickCPFilter
        this.tickeCp_Filter = {
          ListGrp41: store.value,
          ListDepId: store.value2,
          ListUsers: store.value3,
          ListGrp45: store.value4,
          tblCustomerId: store.customerId
        }

        let url = 'Ticket/Get_FilredTicketForChatRoom/' + this.pageInationFiltredTickets.page
        this.$PostData_new('post', url, this.tickeCp_Filter).then((response) => {

          this.pageInationFiltredTickets.totalPage = response.TotalCount / this.pageInationFiltredTickets.pageSize
          if (!(response.TotalCount % this.pageInationFiltredTickets.pageSize == 0)) {
            this.pageInationFiltredTickets.totalPage++
          }
          this.pageInationFiltredTickets.totalPage = parseInt(this.pageInationFiltredTickets.totalPage)
          let filterdTickets = this.set_TicektLogo(response.Tickets)
          setTimeout(() => {
            this.filterdTickets = filterdTickets
          }, 220);
          this.join_ChatRoom_Group(response.Tickets).then(() => {
            // this.filterdTickets = filterdTickets
          })

        }).catch((err) => {
          console.error(err)
          this.$mySweetDefaultTost("عملیات ناموفق", "خطا در خواندن تیکت های جاری", "error", 1600);
        })
      }
    },
    join_ChatRoom_Group(listTicekts) {
      return new Promise((success, reject) => {
        var chatRoomIds = ""
        listTicekts.forEach((el) => {
          chatRoomIds += el.TblChatRoomId + ","
        })
        chatRoomIds = chatRoomIds.slice(0, chatRoomIds.length - 1)
        if (this.signalRChatConnection == null) {
          setTimeout(() => {
            this.signalRChatConnection.invoke("JoinDeaprtmentTicketGroup", chatRoomIds).then(() => {
              success()
            }).catch((err) => {
              console.error("خطا در ورود به گروه های تیکت جاری 0", err);
            })
          }, 1100);
        } else {
          this.signalRChatConnection.invoke("JoinDeaprtmentTicketGroup", chatRoomIds).then(() => {
            success()
          }).catch((err) => {
            console.error("خطا در ورود به گروه های تیکت جاری 1", err);
          })
        }
      })

    },

    set_TicektLogo(listTicekts) {
      for (let index = 0; index < listTicekts.length; index++) {
        let svgCustomer = createAvatar(style, {
          seed: listTicekts[index].TblCustomerId + "",
        });
        var svg64Customer = btoa(unescape(encodeURIComponent(svgCustomer)));
        this.CustomerLogo = "data:image/svg+xml;base64," + svg64Customer;
        listTicekts[index].CustomerLogo = this.CustomerLogo;
      }
      return listTicekts
    },

    checkOnlineUser_Invoke() {
      this.onlineUserChatRoom = []
      this.signalRTicketConnection.invoke('CheckOnlineUser', String(this.ticketId), String(this.userId))
    },

    checkOnlineUser_Called(ticketId, userIdCall) {
      if (this.ticketId == ticketId & this.userId != userIdCall) {
        this.signalRTicketConnection.invoke('OnlineChatRoom', String(this.ticketId), this.nameFam, userIdCall)
      }
    },

    onlineChatRoom_Called(ticketId, namFam) {
      if (this.ticketId == ticketId) {
        this.onlineUserChatRoom.push(namFam)
      }
    },

    leftChatRoomOnline_Invoke() {
      return new Promise((success, reject) => {
        this.signalRTicketConnection.invoke('LeftChatRoom', String(this.ticketId), this.nameFam)
          .then(() => {
            success()
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    LeftChatRoom_Called(ticketId, nameFam) {
      if (this.ticketId == ticketId) {
        let find = this.onlineUserChatRoom.find(x => x == nameFam)
        if (find != undefined) {
          let index = this.onlineUserChatRoom.indexOf(find)
          this.onlineUserChatRoom.splice(index, 1)
        }
      }
    },

    getLastTicektId_cookie() {
      if (this.ticketId == undefined || this.ticketId == null) {
        let key = 'lastTicket_'
        let lastTickId = this.$cookies.get(key)
        if (lastTickId != undefined || lastTickId != null) {
          this.ticketId = lastTickId
        }
      }
    },

    getDepartmentUser() {
      let Dataaxios = {
        Action: "Department/GetDeparmentByUsersForChatRoom",
        Method: "Get",
        ArryfildValue: {}
      }
      this.$PostData(Dataaxios).then((response) => {
        this.departmentUser = response
      }).catch((err) => {
        console.error('CATCH', err)
      })
    },

    setCookieLastMess() {
      var now = new Date();
      var time = now.getTime();
      time += 259200 * 10000;
      now.setTime(time);
      if (this.ticketId != undefined & this.ticketId != null) {
        if (this.newMessage != null) {
          let message = this.newMessage.replace(/\s/g, "");
          if (message != '') {
            let key = '#' + this.ticketId + '_' + this.userId
            this.$cookies.set(key, this.newMessage, now)
          }
        }
      }
    },

    getCookieLastMess() {
      let key = '#' + this.ticketId + '_' + this.userId
      let mess = this.$cookies.get(key)
      if (mess != null & mess != undefined) {
        this.newMessage = mess
      }
    },

    closeTicket() {
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: 'btn btn-success mx-1',
          cancelButton: 'btn btn-danger',
        },
        buttonsStyling: false,
      })
      swalWithBootstrapButtons.fire({
        title: 'اطمینان دارید؟',
        text: 'از بستن تیکت ',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'بله',
        cancelButtonText: 'لغو',
        reverseButtons: true,
      })
        .then((result) => {
          if (result.isConfirmed) {
            this.signalRChatConnection
              .invoke("ChangeStatus", String(this.ticketId), String(1796), String(this.tblUserGrpIdInsert), String(this.departmentId), String(this.chatRoomId))
              .then((res) => {
                this.$mySweetDefaultTost("عملیات موفق", "تیکت با موفقیت بسته شد", "success", 1000);

                this.tblComboIdTicketStatus = 1796
                var record = this.myTickets.find((element) => element.Id == this.ticketId);
                var recordDep = this.DeaprtmentTicket.find((element) => element.Id == this.ticketId);
                let filtreTicket = this.filterdTickets.find((element) => element.Id == this.ticketId);

                if (filtreTicket != undefined & this.myTicketPage == 0) {
                  if (this.check_tickeCp_Filter(1796, 'grp41')) {
                    filtreTicket.TblComboGrpId41 = 1796;
                    filtreTicket.NameGrp41 = 'بسته شده';
                  } else {
                    this.initializeFilteredTicket()
                  }
                }

                if (record != undefined) {
                  record.TblComboGrpId41 = 1796;
                  record.NameGrp41 = 'بسته شده';
                  const index = this.myTickets.indexOf(record);
                  this.myTickets.splice(index, 1);
                }
                if (recordDep != undefined) {
                  recordDep.TblComboGrpId41 = 1796;
                  recordDep.NameGrp41 = 'بسته شده';
                }

              })
              .catch((error) => {
                this.$mySweetDefaultTost("عملیات ناموفق", "خطایی رخ داد", "error", 2000);
                console.error("CATCH", error);
              });
          }

        })

    },

    customerCloseTicket() {
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: 'btn btn-success mx-1',
          cancelButton: 'btn btn-danger',
        },
        buttonsStyling: false,
      })
      swalWithBootstrapButtons.fire({
        title: 'اطمینان دارید؟',
        text: 'از بستن تیکت ',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'بله',
        cancelButtonText: 'لغو',
        reverseButtons: true,
      })
        .then((result) => {
          if (result.isConfirmed) {
            this.signalRChatConnection
              .invoke("ChangeStatus", String(this.ticketId), String(1796), String(this.tblUserGrpIdInsert), String(this.departmentId), String(this.chatRoomId))
              .then((res) => {
                this.$mySweetDefaultTost("عملیات موفق", "تیکت با موفقیت بسته شد", "success", 1500);
                this.tblComboIdTicketStatus = 1796
              })
              .catch((error) => {
                this.$mySweetDefaultTost("عملیات ناموفق", "خطایی رخ داد", "error", 2000);
                console.error("CATCH", error);
              });
          }

        })
    },

    removeCookieLastMess() {
      let key = '#' + this.ticketId + '_' + this.userId
      this.$cookies.remove(key)
    },

    showModalTicketStatus() {
      this.modalTicketStatus = true
      this.submitTicketStatusRequest.TblUserId = this.ticketManagerTblUserId
      this.submitTicketStatusRequest.TblComboGrpId41 = this.tblComboIdTicketStatus
      this.submitTicketStatusRequest.TblComboGrpId42 = this.grp42Id
      this.submitTicketStatusRequest.TblComboGrpId45 = this.grp45Id
      this.getUserDepartment(this.ticketManagerTblUserId)
    },

    getUserDepartment(userId) {
      this.departmentUserOption = []
      this.departmentUser.forEach(x => {
        let exsit = x.usersInDep.filter(p => p.userId == userId).length == 1
        if (exsit) {
          let option = {
            departmentId: x.departmentId,
            departmentName: x.departmentName
          }
          this.departmentUserOption.push(option)
        }
      })
    },

    submitTicketStatus() {
      let selectList = document.getElementById('selectedDepartment')
      let newDepId = selectList.value
      let newTblUserId = this.submitTicketStatusRequest.TblUserId
      let newGrp41 = this.submitTicketStatusRequest.TblComboGrpId41
      let newGrp42 = this.submitTicketStatusRequest.TblComboGrpId42
      let newGrp45 = this.submitTicketStatusRequest.TblComboGrpId45
      let nameGrp41 = this.submitTicketStatusRequest.NameGrp41

      if (newTblUserId == this.ticketManagerTblUserId & newGrp41 == this.tblComboIdTicketStatus & newGrp42 == this.grp42Id
        & newGrp45 == this.grp45Id & this.departmentId == newDepId) {
        this.$toasted.info("تغییرات را وارد نمایید", {
          action: {
            text: "بستن",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            },
          },
        });
        return
      }

      if (newTblUserId == null || newTblUserId == '') {
        newTblUserId = 0
        this.submitTicketStatusRequest.TblUserId = 0
      }
      if (newDepId == null || newDepId == '') {
        newDepId = 0
      }

      if (newTblUserId != 0 & newDepId == 0) {
        this.$toasted.error("دپارتمان تیکت را مشخص نمایید", {
          action: {
            text: "بستن",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            },
          },
        });
        return
      }

      if (newGrp45 == null || newGrp45 == '' || newGrp45 == undefined) {
        this.$toasted.error("نوع تیکت را مشخص نمایید", {
          action: {
            text: "بستن",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            },
          },
        });
        return
      }

      this.submitTicketStatusRequest.TicketId = this.ticketId
      this.submitTicketStatusRequest.TblDepartmentId = newDepId
      let request = JSON.stringify(this.submitTicketStatusRequest)


      this.signalRTicketConnection
        .invoke('ChangeTicketStatus', request)
        .then(() => {
          this.modalTicketStatus = false
          this.ticketManagerTblUserId = this.submitTicketStatusRequest.TblUserId
          this.tblComboIdTicketStatus = this.submitTicketStatusRequest.TblComboGrpId41
          this.grp42Id = this.submitTicketStatusRequest.TblComboGrpId42
          this.grp45Id = this.submitTicketStatusRequest.TblComboGrpId45
          this.departmentId = newDepId
          this.$mySweetDefaultTost('عملیات موفق', 'تغییرات با موفقیت ثبت شد', 'success', 2000)

          var record = this.myTickets.find((element) => element.Id == this.ticketId);
          var recordDep = this.DeaprtmentTicket.find((element) => element.Id == this.ticketId);
          var filtreTicket = this.filterdTickets.find(x => x.Id == this.ticketId)
          //#region  after rfrence change
          if (newTblUserId != this.userId) {
            if (record != undefined) {
              const index = this.myTickets.indexOf(record);
              this.myTickets.splice(index, 1);
            }
          }

          if (recordDep != undefined) {
            recordDep.TblUserId = newTblUserId;
          }
          //#endregion
          //#region  after status change
          this.tblComboIdTicketStatus = newGrp41
          if (record != undefined) {
            record.TblComboGrpId41 = newGrp41;
            record.NameGrp41 = nameGrp41;

            record.TblDepartmentId = newDepId;
            record.TblComboGrpId45 = newGrp45
            record.TblComboGrpId42 = newGrp42
          }
          if (recordDep != undefined) {
            recordDep.TblComboGrpId41 = newGrp41;
            recordDep.NameGrp41 = nameGrp41;

            recordDep.TblDepartmentId = newDepId;
            recordDep.TblComboGrpId45 = newGrp45
            recordDep.TblComboGrpId42 = newGrp42

          }
          if (newGrp41 == 1796) {
            var record = this.myTickets.find((element) => element.Id == this.ticketId);
            const index = this.myTickets.indexOf(record);
            this.myTickets.splice(index, 1);
          }

          if (this.myTicketPage == 0) {
            this.initializeFilteredTicket()
          }
          //#endregion

        }).catch((err) => {
          this.$toasted.error("خطایی رخ داد", {
            action: {
              text: "بستن",
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
              },
            },
          });
          console.error('CATCH', err)
        })

    },
    getTicketInfo() {
      if(this.ticketId == undefined){
        this.ticketId = this.$cookies.get('lastTicket_')
      }
      return new Promise((success, reject) => {
        if (this.ticketId != undefined || this.ticketId != null) {
          let Dataaxios = {
            Action: "ChatRoom/GetTicketInfo/" + this.ticketId,
            Method: "Get",
            ArryfildValue: {}
          }

          this.$PostData(Dataaxios).then((response) => {
            this.chatRoomId = response.TblChatRoomId
            this.ticketManagerTblUserId = response.TblUserId
            this.ticketId = response.Id
            this.tblComboIdTicketStatus = response.TblComboGrpId41
            this.customerName = response.CustomerName
            this.departmentId = response.TblDepartmentId
            this.customerCode = response.CustomerCode
            this.grp45Id = response.TblComboGrpId45
            this.grp42Id = response.TblComboGrpId42
            this.CId = response.TblCustomerId
            this.tblCombogrp37AxarinVazeit = response.tblCombogrp37AxarinVazeit
            success()
            let DataaxiosChatroom = {
              Action: "ChatRoom/GetChatRoomMessage",
              Method: "Post",
              ArryfildValue: {
                ChatRoomId: this.chatRoomId,
                IsCustomer: this.$session.get("CustomerInfo") != undefined && this.$session.get("CustomerInfo").Id > 0 ? true : false,
              }
            }
            this.$PostData(DataaxiosChatroom)
              .then((response) => {
                response.forEach((element) => {
                  if (element.TblComboGrpId43 == 1804 || element.TblComboGrpId43 == 2500) {
                    element.isDownload = false;
                    element.downloading = false;
                    element.src = "";
                  }

                });
                this.chatMessage = response;
                this.messageLinks();
                // this.showIconReply()
              })
              .catch((error) => {
                console.error("CATCH", error);
              })

          }).catch((error) => {
            this.$mySweetDefaultTost("عملیات ناموفق", "خطا در خواندن اطلاعات تیکت", "error", 3000);
            console.error("CATCH", error);
          })
        }
      })


    },

    seenFirstMessage() {
      if (!this.isCustomer) {
        let lastMess = this.chatMessage[this.chatMessage.length - 1]
        let notes = this.chatMessage.filter(x => (x.TblComboGrpId43 == 1803 || x.TblComboGrpId43 == 2500 || x.TblComboGrpId43 == 2501) & !x.IsView)

        if ((lastMess.TblUserId > 0 & lastMess.TblUserGrpIdInsert != this.tblUserGrpIdInsert & !lastMess.IsView) || notes.length > 0) {
          this.signalRChatConnection.invoke("ViewFirstMessageAndNotes", String(this.chatRoomId), String(lastMess.Id));
        }
      }
    },

    OnDetail(Id) {
      var DataAxios = {
        Action: 'Ticket/GetTicketLog',
        Method: 'Get',
        ArryfildValue: {
          Id: Id,
        },
      }
      this.$GetData_Header(DataAxios)
        .then((response) => {
          this.rows = response
        })
        .finally(() => {
          this.$store.state.renderComponentGridModal = false
          this.$nextTick(() => {
            this.$store.state.Modal = true

            this.$store.state.renderComponentGridModal = true
          })
        })
    },

    sortMessageChange() {
      var now = new Date();
      var time = now.getTime();
      time += 2592000 * 1000000;
      now.setTime(time);
      if (this.sortMess == true) {
        this.$cookies.set('sortMessage', 'false', now)
        this.sortMess = false
      } else {
        this.$cookies.set('sortMessage', 'true', now)
        this.sortMess = true
      }
    },

    ChangeDepartment() {
      let departmentId = document.getElementById('changeDepSelectList').value

      this.signalRTicketConnection
        .invoke('ChangeDepartment', String(this.changeDepartmentRequest.ticketId), String(departmentId))
        .then((res) => {
          this.$toasted.success("دپارتمان تیکت با موفقیت تغییر کرد", {
            action: {
              text: "بستن",
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
              },
            },
          });
          this.submitTicketStatusRequest.TblUserId = this.changeDepartmentRequest.userIdTask
          this.showModalRefrence = false

          //ارجاع پس از تغییر دپارتمان
          // this.signalRTicketConnection
          //   .invoke("ReferenceTicket", String(this.changeDepartmentRequest.ticketId), String(this.changeDepartmentRequest.userIdTask), String(this.tblUserGrpIdInsert))
          //   .then((res) => {
          //     this.$mySweetDefaultTost("عملیات موفق", "تیکت با موفقیت ارجاع شد", "success", 2000);
          //     this.ticketManagerTblUserId = this.changeDepartmentRequest.userIdTask
          //     if (this.changeDepartmentRequest.userIdTask != this.userId) {
          //       var record = this.myTickets.find((element) => element.Id == this.ticketId);
          //       if (record != undefined) {
          //         const index = this.myTickets.indexOf(record);
          //         this.myTickets.splice(index, 1);
          //       }
          //     }
          //     var recordDep = this.DeaprtmentTicket.find((element) => element.Id == this.ticketId);
          //     if (recordDep != undefined) {
          //       recordDep.TblUserId = this.changeDepartmentRequest.userIdTask;
          //     }
          //     this.showModalRefrence = false
          //   })
          //   .catch((error) => {
          //     this.$mySweetDefaultTost("عملیات ناموفق", "خطایی رخ داد", "error", 2000);
          //     console.error("CATCH", error);
          //   });
        })
        .catch((error) => {
          this.$mySweetDefaultTost('عملیات ناموفق', 'خطایی رخ داد', 'error', 2000)
          console.error('CATCH', error)
          this.modalTicketStatus = false
        })

    },

    GetResultGrp42(data) {
      if (data.id != null && !data.IsDefault) {
        // this.grp42Id = data.id
        this.submitTicketStatusRequest.TblComboGrpId42 = data.id

        // this.signalRTicketConnection
        //   .invoke('ChangeTicketImportant', String(this.ticketId), String(data.id))
        //   .then((res) => {
        //     this.$toasted.success('اهمیت تیکت با موفقیت نغییر یافت', {
        //       action: {
        //         text: 'بستن',
        //         onClick: (e, toastObject) => {
        //           toastObject.goAway(0)
        //         },
        //       },
        //     })

        //     var record = this.myTickets.find((element) => element.Id == this.ticketId);
        //     var recordDep = this.DeaprtmentTicket.find((element) => element.Id == this.ticketId);
        //     if (record != undefined) {
        //       record.TblComboGrpId42 = data.id;
        //     }
        //     if (recordDep != undefined) {
        //       recordDep.TblComboGrpId42 = data.id;
        //     }

        //   })
        //   .catch((error) => {
        //     this.$mySweetDefaultTost('عملیات ناموفق', 'خطایی رخ داد', 'error', 2000)
        //     console.error('CATCH', error)
        //   })
      }
    },
    GetResultGrp45(data) {
      if (data.id != null && !data.IsDefault) {

        // this.grp45Id = data.id
        this.submitTicketStatusRequest.TblComboGrpId45 = data.id

        // this.signalRTicketConnection
        //   .invoke('Grp45Ticket', String(this.ticketId), String(this.$session.get('UserInfo').tblUserGrpId), String(data.id))
        //   .then((res) => {
        //     this.$toasted.success('توع تیکت با موفقیت نغییر یافت', {
        //       action: {
        //         text: 'بستن',
        //         onClick: (e, toastObject) => {
        //           toastObject.goAway(0)
        //         },
        //       },
        //     })

        //     var record = this.myTickets.find((element) => element.Id == this.ticketId);
        //     var recordDep = this.DeaprtmentTicket.find((element) => element.Id == this.ticketId);
        //     if (record != undefined) {
        //       record.TblComboGrpId45 = data.id;
        //     }
        //     if (recordDep != undefined) {
        //       recordDep.TblComboGrpId45 = data.id;
        //     }

        //   })
        //   .catch((error) => {
        //     this.$mySweetDefaultTost('عملیات ناموفق', 'خطایی رخ داد', 'error', 2000)
        //     console.error('CATCH', error)
        //   })
      }
    },
    GetResultGrp41(data) {
      if (data.id != null && !data.IsDefault) {

        // this.tblComboIdTicketStatus = data.id
        this.submitTicketStatusRequest.TblComboGrpId41 = data.id
        this.submitTicketStatusRequest.NameGrp41 = data.name
        // this.signalRChatConnection
        //   .invoke("ChangeStatus", String(this.ticketId), String(data.id), String(this.tblUserGrpIdInsert), String(this.departmentId), String(this.chatRoomId))
        //   .then((res) => {
        //     this.$mySweetDefaultTost("عملیات موفق", "وضعیت تیکت با موفقیت تغییر کرد", "success", 1000);

        //     this.tblComboIdTicketStatus = data.id
        //     var record = this.myTickets.find((element) => element.Id == this.ticketId);
        //     var recordDep = this.DeaprtmentTicket.find((element) => element.Id == this.ticketId);
        //     if (record != undefined) {
        //       record.TblComboGrpId41 = data.id;

        //       record.NameGrp41 = data.name;
        //     }
        //     if (recordDep != undefined) {
        //       recordDep.TblComboGrpId41 = data.id;
        //       recordDep.NameGrp41 = data.name;
        //     }
        //     if (data.id == 1796) {
        //       var record = this.myTickets.find((element) => element.Id == this.ticketId);
        //       const index = this.myTickets.indexOf(record);
        //       this.myTickets.splice(index, 1);
        //     }
        //   })
        //   .catch((error) => {
        //     this.$mySweetDefaultTost("عملیات ناموفق", "خطایی رخ داد", "error", 2000);
        //     console.error("CATCH", error);
        //   });
      }
    },

    getLastTicket(TicketId) {
      return new Promise((success, reject) => {

        this.DataaxiosDepUser.Action = "Ticket/GetLastTicket";
        this.DataaxiosDepUser.Method = "Get";
        this.DataaxiosDepUser.ArryfildValue = { Id: TicketId };

        this.$GetData_Header(this.DataaxiosDepUser)
          .then((res) => {
            let svgCustomer = createAvatar(style, {
              seed: res.TblCustomerId + "",
            });
            var svg64Customer = btoa(unescape(encodeURIComponent(svgCustomer)));
            this.CustomerLogo = "data:image/svg+xml;base64," + svg64Customer;
            res.CustomerLogo = this.CustomerLogo;
            success(res)
          }).catch((err) => {
            reject(err)
          })
      })
    },

    saveIdLastTicket() {
      // در صفحه تیکت سی پی هم هست
      var now = new Date();
      var time = now.getTime();
      time += 259200 * 1000;
      now.setTime(time);
      if (this.ticketId != undefined & this.ticketId != null & !this.isCustomer) {
        let key = 'lastTicket_'
        this.$cookies.set(key, this.ticketId, now)
      }
    },

    showIconRemoveMess(mousEnter, indexMess, ev, mess) {

      if (!this.$IsAccess("btnEditMessage")) {
        return
      }

      // اگر اولین پیام بود و پشتیبان ایجاد کرده بود نباید پشتیبان بتواند پیام را ویرایش کند
      let length = this.chatMessage.length - 1
      if (indexMess == length & mess.TblUserGrpIdInsert != this.tblUserGrpIdInsert) {
        return
      }

      if ((mess.TblComboGrpId43 == 1803 || mess.TblComboGrpId43 == 2500 || mess.TblComboGrpId43 == 2501) & mess.TblUserGrpIdInsert != this.tblUserGrpIdInsert) {
        return
      }

      if (ev != undefined) {
        let icons = ev.target
        if (mousEnter) {
          var removeIcon = icons.querySelectorAll('.remove-meesage')
          removeIcon.forEach(element => {
            element.classList.remove('d-none')
          });
        }
        else if (!mousEnter) {
          var removeIcon = icons.querySelectorAll('.remove-meesage')
          removeIcon.forEach(element => {
            element.classList.add('d-none')
          });
        }
      }
    },
    removeMessage(item) {
      if (this.$IsAccess("btnEditMessage")) {
        const swalWithBootstrapButtons = this.$swal.mixin({
          customClass: {
            confirmButton: 'btn btn-success mx-1',
            cancelButton: 'btn btn-danger',
          },
          buttonsStyling: false,
        })
        swalWithBootstrapButtons.fire({
          title: 'اطمینان دارید؟',
          text: 'از حذف پیام',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'بله، حذف شود',
          cancelButtonText: 'لغو',
          reverseButtons: true,
        })
          .then((result) => {
            if (result.isConfirmed) {
              this.signalRChatConnection.invoke("RemoveMessage", String(item.Id))
            }
          })
      }
    },
    // tryConnectTicketHub() {
    //   if (!this.ticketHubConnected) {
    //     if (!this.manualStopHub) {
    //       this.ticketHub().then(() => {
    //         this.ticketHubConnected = true;
    //         clearInterval(this.ticketInterval);
    //       });
    //     }
    //   }
    // },
    // tryConnectChatHub() {
    //   if (!this.chattHubConnected) {
    //     if (!this.manualStopHub) {
    //       this.chatHub().then(() => {
    //         this.chattHubConnected = true;
    //         clearInterval(this.chatHubInterval);
    //       });
    //     }
    //   }
    // },
    async chatHub() {
      this.$GetSignalRChat()
        .then((res) => {
          this.signalRChatConnection = res;
          this.connectionIdChat = res.connection.connectionId;
          res.invoke("UserJoinChatRoom", String(this.chatRoomId)).then(() => {})
            .catch((err) => {
              console.error("خطا در اتصال به گروه های تیکت 0", err);
              setTimeout(() => {
                res.invoke("UserJoinChatRoom", String(this.chatRoomId)).catch((err) => {
                  console.error("خطا در اتصال به گروه های تیکت 1", err);
                })
              }, 1500);
            });
          res.invoke("UserJoinGroup", String(this.userId));
          if (this.isCustomer) {
            res.invoke("ViewMessage", String(this.chatRoomId));
          }
          // تلاش برای اتصال هاب در صورت قطع شدن
          // this.signalRChatConnection.onclose(() => {
          //   if (!this.manualStopHub) {
          //     this.$swal.fire({
          //       position: "top-end",
          //       icon: "error",
          //       title: "اتصال شما با سرور قطع شد",
          //       showConfirmButton: false,
          //       timer: 5000,
          //     });
          //     this.chattHubConnected = false;
          //     this.chatHubInterval = setInterval(this.tryConnectChatHub, 1000);
          //   }
          // });

          this.signalRChatConnection.onclose(() => {
            if (!this.manualStopHub) {
              this.$swal.fire({
                position: "top-end",
                icon: "error",
                title: "اتصال شما با سرور قطع شد صفحه را رفرش نمایید",
                showConfirmButton: false,
                timer: 15000,
              });
            }
          })

          res.on("getNewMessage", (messageJsonString, namFam, fileSrc, tblComboGrpId41) => {
            let newMessage = JSON.parse(messageJsonString)
            newMessage.FileSrc = fileSrc
            newMessage.NamFam = namFam

            if (this.chatRoomId == newMessage.TblChatRoomId) {
              if (this.isCustomer) {
                this.signalRChatConnection.invoke("ViewMessage", String(this.chatRoomId));
              }

              if (newMessage.TblComboGrpId43 == 1804 || newMessage.TblComboGrpId43 == 2500) {
                newMessage.isDownload = false;
                newMessage.downloading = false;
                newMessage.src = "";
              }

              let messageExsit = false;
              this.chatMessage.forEach((element) => {
                if (element.Id == newMessage.Id) {
                  messageExsit = true;
                }
              });

              if (!messageExsit) {
                this.chatMessage.unshift(newMessage);
                this.messageLinks();
                // this.showIconReply()
              }
              this.DataaxiosDepUser.Action = "ChatRoom/ViewMessage";
              this.DataaxiosDepUser.Method = "Post";
              this.DataaxiosDepUser.ArryfildValue = {
                ChatRoomId: newMessage.TblChatRoomId,
                IsCustomer: this.isCustomer,
              };
              this.$PostData(this.DataaxiosDepUser)
                .then((res) => { })
                .catch((err) => {
                  console.error("CATCH", err);
                });

              this.seenFirstMessage()

              // مشکل نمایش ریپلای مسیج مشتری
              if (this.isCustomer) {
                if(newMessage.ReplyMessageId != null){
                  this.getNowChatMeesage()  
                }       
              }

            } else {
              var record = this.myTickets.find((element) => element.TblChatRoomId == newMessage.TblChatRoomId);
              var recordDep = this.DeaprtmentTicket.find((element) => element.TblChatRoomId == newMessage.TblChatRoomId)
              let filtreTicket = this.filterdTickets.find(x => x.TblChatRoomId == newMessage.TblChatRoomId)

              if (filtreTicket != undefined) {
                filtreTicket.UnseenMessage += 1;
              }

              if (record != undefined) {
                record.UnseenMessage += 1;
              }

              if (recordDep != undefined) {
                recordDep.UnseenMessage += 1;
              }
              // else{
              //   this.notifDepTicket = 'پیام جدید'
              // } 

            }
            if (!this.isCustomer) {
              var record = this.myTickets.find((element) => element.TblChatRoomId == newMessage.TblChatRoomId);
              var recordDep = this.DeaprtmentTicket.find((element) => element.TblChatRoomId == newMessage.TblChatRoomId)

              if (record != undefined) {
                record.TblComboGrpId41 = tblComboGrpId41;
                record.DateTimeLastEdit = newMessage.DateTimeInsert;
                var status = this.ticketStatus.find((x) => x.id == tblComboGrpId41);
                record.NameGrp41 = status.name;
              }
              if (recordDep != undefined) {
                recordDep.TblComboGrpId41 = tblComboGrpId41;
                recordDep.DateTimeLastEdit = newMessage.DateTimeInsert;
                var status = this.ticketStatus.find((x) => x.id == tblComboGrpId41);
                recordDep.NameGrp41 = status.name;
              }
            }
            // this.showIconReply()
          });

          res.on('notifNewMessageInChatRoom', (ticketId, ticketMangeUserId) => {
            if (this.userId == ticketMangeUserId) {
              let ticket = this.myTickets.find(x => x.Id == ticketId)
              if (ticket == undefined) {
                this.notifMyTicket = 'پیام جدید'
              }
            } else {
              let ticketDep = this.DeaprtmentTicket.find(x => x.Id == ticketId)
              if (ticketDep == undefined) {
                this.notifDepTicket = 'پیام جدید'
              }
            }
            // this.refreshTickets()
          })


          res.on("changeStatus", (ticketId, status, tblComboIdTicketStatus) => {
            this.signalr_changeStatus(ticketId, status, tblComboIdTicketStatus)
          });

          res.on("getEditedMessage", (messageId, message) => {
            var record = this.chatMessage.find((element) => element.Id == messageId);
            if (record != undefined) {
              record.Message = message;
              this.messageLinks();
              // this.showIconReply()
              this.render = false
              this.$nextTick(() => {
                this.render = true
              })
            }
          });

          res.on("removeMessage", (messageId) => {
            var record = this.chatMessage.find((element) => element.Id == messageId);
            if (record != undefined) {
              const index = this.chatMessage.indexOf(record);
              this.chatMessage.splice(index, 1);
              // this.showIconReply()
            }
          });

          res.on("getNewScore", (messageId, score) => {
            var record = this.chatMessage.find((element) => element.Id == messageId);
            record.score = score;
          });

          if (!this.isCustomer) {
            res.on("ViewMessage", (roomId) => {
              if (this.chatRoomId == roomId) {
                var messages = this.chatMessage.slice(0, 20)
                  .filter(x => !(x.TblComboGrpId43 == 1803 || x.TblComboGrpId43 == 2500 || x.TblComboGrpId43 == 2501))
                messages.forEach(element => {
                  if (element.TblUserId > 0) {
                    element.IsView = true
                  }
                });
              }
            })
          }

          if (!this.isCustomer) {
            res.on("ViewFirstMessageAndNotes", (roomId, messageId) => {
              if (this.chatRoomId == roomId) {
                var messages = this.chatMessage.find(x => x.Id == messageId)
                messages.IsView = true
                var messages = this.chatMessage.slice(0, 20)
                  .filter(x => x.TblComboGrpId43 == 1803 || x.TblComboGrpId43 == 2500 || x.TblComboGrpId43 == 2501)
                messages.forEach(element => {
                  element.IsView = true
                });

              }
            })
          }

          setTimeout(() => {
            try {
              this.seenFirstMessage()
            }
            catch { }
          }, 1200);

        })
        .catch((error) => {
          this.$mySweetDefaultTost("عملیات ناموفق", "خطا در ایجاد اتصال لطفا مجددا تلاش کنید", "error", 6000);
          console.error("CATCH", error);
        })
      // .finally(() => {
      //   if (this.signalRChatConnection._connectionStarted === false || this.signalRChatConnection == null) {
      //     setTimeout(() => {
      //       this.chatHub();
      //     }, 1000);
      //   }
      // });

    },

    async ticketHub() {
      this.$GetSignalR()
        .then((res) => {
          this.signalRTicketConnection = res;
          this.connectionId = res.connection.connectionId;
          res.invoke("UserJoinGroup", String(this.userId));
          res.invoke("UserJoinChatRoom", String(this.chatRoomId));

          // تلاش برای اتصال هاب در صورت قطع شدن
          // this.signalRTicketConnection.onclose(() => {
          //   if (!this.manualStopHub) {
          //     this.ticketHubConnected = false;
          //     this.ticketInterval = setInterval(this.tryConnectTicketHub, 1000);
          //   }
          // });

          if (!this.isCustomer) {
            res.on('CheckOnlineUser', this.checkOnlineUser_Called)

            res.on('OnlineChatRoom', this.onlineChatRoom_Called)

            res.on('LeftChatRoom', this.LeftChatRoom_Called)
          }


          res.on('Grp45Ticket', (ticketId, grp45Id) => {
            let ticket = this.myTickets.find(x => x.Id == ticketId)
            if (ticket != undefined) {
              ticket.TblComboGrpId45 = grp45Id
            }

            if (ticketId == this.ticketId) {
              this.grp45Id = grp45Id
            }

            let ticketDep = this.DeaprtmentTicket.find(x => x.Id == tickId)
            if (ticketDep != undefined) {
              ticketDep.TblComboGrpId45 = grp45Id
            }

            this.render = false
            this.$nextTick(() => {
              this.render = true
            })

            this.IsIdUser = false
            this.$nextTick(() => {
              this.IsIdUser = true
            })
          })

          res.on("ReferenceTicket", (TicketId, TblChatRoomId) => {
            var tickId = parseInt(TicketId);
            var isExsit = false;
            for (var i = 0; i < this.myTickets.length; i++) {
              if (tickId == this.myTickets[i].Id) {
                isExsit = true;
              }
            }

            let joinChatRoomGroup = false
            this.DeaprtmentTicket.forEach((el) => {
              if (el.Id == tickId) {
                joinChatRoomGroup = true
              }
            })

            if (!isExsit) {
              if (joinChatRoomGroup) {
                this.notifMyTicket = 'ارجاع'

              } else {
                this.signalRChatConnection.invoke("UserJoinChatRoom", String(TblChatRoomId)).then(() => {
                  this.notifMyTicket = 'ارجاع'
                });
              }

            }
            this.refreshTickets()
          });


          res.on("changeDepartment", (tickId, departmentId) => {
            let ticket = this.myTickets.find(x => x.Id == tickId)
            if (ticket != undefined) {
              ticket.TblDepartmentId = departmentId
            }

            if (tickId == this.ticketId) {
              this.departmentId = departmentId
            }

            let ticketDep = this.DeaprtmentTicket.find(x => x.Id == tickId)
            if (ticketDep != undefined) {
              ticketDep.TblDepartmentId = departmentId
            }

            this.IsIdUser = false
            this.$nextTick(() => {
              this.IsIdUser = true
            })

          });

          res.on("changeStatus", (ticketId, status, tblComboIdTicketStatus) => {
            this.signalr_changeStatus(ticketId, status, tblComboIdTicketStatus)
          });

          res.on('GetNotif', (ticketId, chatRoomId, tblUserId) => {
            this.signalRChatConnection.invoke("UserJoinChatRoom", String(chatRoomId)).then(() => {
              this.notifDepTicket = 'تیکت جدید'

              if (tblUserId == this.userId) {
                this.notifMyTicket = 'ارجاع'
              }

              // this.getLastTicket(ticketId).then((res) => {
              //   this.DeaprtmentTicket.unshift(res);
              // }).catch((err)=>{
              //     console.error("CATCH", err);
              // })

              this.refreshTickets()
            });
          })

          res.on('ReferenceTicketDepartment', (ticketId, tblUserId, depId) => {
            var tickId = parseInt(ticketId);
            var userId = parseInt(tblUserId);
            let findTicket = this.DeaprtmentTicket.find(x => x.Id == tickId)
            if (findTicket != undefined) {
              findTicket.TblUserId = userId
            }

            if (this.ticketId == tickId) {
              this.ticketManagerTblUserId = userId
              this.IsIdUser = false
              this.$nextTick(() => {
                this.IsIdUser = true
              })
            }

            let filtreTicket = this.filterdTickets.find(x => x.Id == ticketId)
            if (this.myTicketPage == 0) {
              if (this.check_tickeCp_Filter(tblUserId, 'user') & this.check_tickeCp_Filter(depId, 'dep')) {
                if(filtreTicket != undefined ){
                  filtreTicket.TblUserId = userId
                  filtreTicket.TblDepartmentId = depId
                }else{
                  this.refreshTickets()
                }
              }else{
                if(filtreTicket != undefined ){
                  let index = this.filterdTickets.indexOf(filtreTicket)
                  this.filterdTickets.splice(index, 1)
                }
              }
            }


          })

        })
        .catch((error) => {
          this.$mySweetDefaultTost("عملیات ناموفق", "خطا در ایجاد اتصال لطفا مجددا تلاش کنید", "error", 2000);
          console.error("CATCH", error);
        })
        .finally(() => {
          if (!this.isCustomer) {
            this.checkOnlineUser_Invoke()
          }
          // if (this.signalRTicketConnection._connectionStarted === false || this.signalRTicketConnection == null) {
          //   setTimeout(() => {
          //     this.ticketHub();
          //   }, 1000);
          // }
        });
    },

    getNotifMyTick() {
      this.pageInationMyTickets.page = 1
      this.myTicket()
      this.notifMyTicket = ''
    },

    getNotifDepTick() {
      this.pageInationDepTickets.page = 1
      this.getDeaprtmentTicket(false)
      this.notifDepTicket = ''
    },

    getNowChatMeesage() {
      (this.DataaxiosDepUser.Action = "ChatRoom/GetChatRoomMessage"),
        (this.DataaxiosDepUser.Method = "Post"),
        (this.DataaxiosDepUser.ArryfildValue = {
          ChatRoomId: this.chatRoomId,
          IsCustomer: this.$session.get("CustomerInfo") != undefined && this.$session.get("CustomerInfo").Id > 0 ? true : false,
        });

      this.$PostData(this.DataaxiosDepUser)
        .then((response) => {
          response.forEach((element) => {
            if (element.TblComboGrpId43 == 1804 || element.TblComboGrpId43 == 2500) {
              element.isDownload = false;
              element.downloading = false;
              element.src = "";
            }
          });
          this.chatMessage = response;

          this.renderChatBox = false
          this.$nextTick(() => {
            this.renderChatBox = true
          })

          this.messageLinks();
          // this.showIconReply()
        })
        .catch((error) => {
          console.error("CATCH", error);
        })
    },
    showIconReply(mouseEnter, ev) {
      if (ev != undefined) {
        let icons = ev.target
        if (mouseEnter) {
          var removeIcon = icons.querySelectorAll('.reply-icon')
          removeIcon.forEach(element => {
            element.classList.remove('d-none')
          });
        }
        else if (!mouseEnter) {
          var removeIcon = icons.querySelectorAll('.reply-icon')
          removeIcon.forEach(element => {
            element.classList.add('d-none')
          });
        }
      }
      // setTimeout(() => {
      //   let replyIcons = document.querySelectorAll('.friend_msg')
      //   replyIcons.forEach((el) => {
      //     el.addEventListener('mouseenter', (ev) => {
      //       let replyIcon = ev.target.getElementsByClassName('reply-icon')[0]
      //       if(replyIcon != undefined){
      //         replyIcon.classList.remove('d-none')
      //       }
      //     })
      //     el.addEventListener('mouseleave', (ev) => {
      //       let replyIcon = ev.target.getElementsByClassName('reply-icon')[0]
      //       if(replyIcon != undefined){
      //         replyIcon.classList.add('d-none')
      //       }
      //     })
      //   })
      // }, 400);
    },
    messageLinks() {
      let char = new RegExp("[\u0600-\u06FF]"); // حروف فارسی 
      this.chatMessage.forEach((element) => {
        element.Link = [];
        element.Separator = [];
        element.MessageLinks = [];

        let linkNum = 1;
        let separator = [];
        //مشخص کردن لینک ها
        for (let i = 0; i < element.Message.length; i++) {
          let https = element.Message.substr(i, 6);
          if (https == "https:") {
            let link = "";
            for (let n = i; n < element.Message.length; n++) {
              if (element.Message[n] == " " || element.Message[n] == "\n") {
                element.Link.push(link);
                // element.Message = element.Message.replace(link,"(" + "لینک " + linkNum + ")")
                linkNum += 1;
                let newSeparator = {
                  start: i,
                  end: n,
                };
                element.Separator.push(newSeparator);
                break;
              }
              if (n == element.Message.length - 1) {
                link += element.Message[n];
                // element.Message = element.Message.replace(link,"(" + "لینک " + linkNum + ")")
                element.Link.push(link);
                linkNum += 1;
                let newSeparator = {
                  start: i,
                  end: n,
                };
                element.Separator.push(newSeparator);
                break;
              }
              link += element.Message[n];
            }
          } else if (https == "http:/") {
            let link = "";
            for (let n = i; n < element.Message.length; n++) {
              if (element.Message[n] == " " || element.Message[n] == "\n") {
                element.Link.push(link);
                let newSeparator = {
                  start: i,
                  end: n,
                };
                element.Separator.push(newSeparator);
                break;
              }
              if (n == element.Message.length - 1) {
                link += element.Message[n];
                element.Link.push(link);
                let newSeparator = {
                  start: i,
                  end: n,
                };
                element.Separator.push(newSeparator);
                break;
              }
              link += element.Message[n];
            }
          }
        }

        //
        if (element.Separator.length > 0) {
          let num = 0;
          let newMessageLink = {
            Message: "",
            IsLink: false,
          };
          let newMessageLinkBetween = {
            Message: "",
            IsLink: true,
          };
          let lastEnd = element.Separator[element.Separator.length - 1].end;
          let isBetween;
          for (let n = 0; n < element.Message.length; n++) {

            for (let i = 0; i < element.Separator.length; i++) {
              if (element.Separator[i].start <= n && n <= element.Separator[i].end) {
                isBetween = true;
                break
              } else {
                isBetween = false;
              }
            }

            if (isBetween) {
              newMessageLinkBetween.Message += element.Message[n];
              newMessageLinkBetween.IsLink = true;
              if (newMessageLink.Message != "") {
                element.MessageLinks.push(newMessageLink);
                newMessageLink = {
                  Message: "",
                  IsLink: false,
                };
              }
              if (lastEnd == element.Message.length - 1 && n == lastEnd) {
                element.MessageLinks.push(newMessageLinkBetween);
              }
            } else {
              newMessageLink.Message += element.Message[n];
              newMessageLink.IsLink = false;
              if (newMessageLinkBetween.Message != "") {
                element.MessageLinks.push(newMessageLinkBetween);
                newMessageLinkBetween = {
                  Message: "",
                  IsLink: true,
                };
              }
              if ((n > lastEnd) & (n == element.Message.length - 1)) {
                element.MessageLinks.push(newMessageLink);
              }
            }

          }
        } else {
          element.MessageLinks.push({
            Message: element.Message,
            IsLink: false,
          });
        }

      });
    },
    replyMessage(mess) {
      this.replyMessageData.id = mess.Id
      this.replyMessageData.mess = mess.Message
      this.replyMessageData.namFam = mess.NamFam
      if (mess.TblComboGrpId43 == 1804) {
        this.replyMessageData.grp43 = 'تصویر'
      }
      if (mess.TblComboGrpId43 == 1805) {
        this.replyMessageData.grp43 = 'فایل'
      }
      if (mess.TblComboGrpId43 == 1802) {
        this.replyMessageData.grp43 = ''
      }
      setTimeout(() => {
        let chatBox = document.getElementById('chat-Box')
        chatBox.scrollTo(0, chatBox.scrollHeight)
      }, 20);
    },
    cancelReply() {
      this.replyMessageData.id = 0
    },
    refreshPage() {
      this.getNowChatMeesage();
      if (!this.isCustomer) {
        if (this.myTicketPage == 1) {
          this.myTicket();
        } else if (this.myTicketPage == 2) {
          this.getDeaprtmentTicket(true)
        } else if (this.myTicketPage == 0) {
          this.initializeFilteredTicket()
        }
      }

      this.$toasted.success("بروزرسانی انجام شد", {
        action: {
          text: "",
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },
        },
      });

    },

    refreshTickets() {
      if (this.myTicketPage == 1) {
        if (this.pageInationMyTickets.page == 1) {
          this.myTicket();
        }
      } else if (this.myTicketPage == 2) {
        if (this.pageInationDepTickets.page == 1) {
          this.getDeaprtmentTicket(true)
        }
      } else if (this.myTicketPage == 0) {
        if (this.pageInationFiltredTickets.page == 1) {
          this.initializeFilteredTicket()
        }
      }
    },

    getDeaprtmentTicket(refreshPage) {

      //در صورتی که یک بار تیکت ها را گرفته دیگر نیاز نیست دوباره بگیرد
      // if(this.JoinDeaprtmentTicketGroup & !refreshPage){
      //   this.myTicketPage = false
      //   return
      // }

      let Dataaxios = {
        Action: "Ticket/GetDepartmentTicketForChatRoom/" + this.pageInationDepTickets.page,
        Method: "Get",
        ArryfildValue: {}
      }

      this.$PostData(Dataaxios).then((response) => {
        //محسابه تعداد صفحات
        this.pageInationDepTickets.totalPage = response.TotalCount / this.pageInationDepTickets.pageSize
        if (!(response.TotalCount % this.pageInationDepTickets.pageSize == 0)) {
          this.pageInationDepTickets.totalPage++
        }
        this.pageInationDepTickets.totalPage = parseInt(this.pageInationDepTickets.totalPage)

        response = response.Tickets

        for (let index = 0; index < response.length; index++) {
          let svgCustomer = createAvatar(style, {
            seed: response[index].TblCustomerId + "",
          });
          var svg64Customer = btoa(unescape(encodeURIComponent(svgCustomer)));
          this.CustomerLogo = "data:image/svg+xml;base64," + svg64Customer;
          response[index].CustomerLogo = this.CustomerLogo;
        }

        var chatRoomIds = ""
        response.forEach((el) => {
          chatRoomIds += el.TblChatRoomId + ","
        })
        chatRoomIds = chatRoomIds.slice(0, chatRoomIds.length - 1)

        //در صورتی که یک بار جوین شده باشد دیگر نیازی نیست
        if (!this.JoinDeaprtmentTicketGroup) {
          this.signalRChatConnection.invoke("JoinDeaprtmentTicketGroup", chatRoomIds).then(() => {
            this.JoinDeaprtmentTicketGroup = true
            this.DeaprtmentTicket = response
            this.notifDepTicket = ''

            if (!refreshPage) {
              this.myTicketPage = 2
            }
          }).catch((err) => {
            console.error("CATCH", err);
            this.$mySweetDefaultTost("عملیات ناموفق", "خطایی در ورود به گروه رخ داد", "error", 2000);
          })
        }
        else {
          this.DeaprtmentTicket = response
          this.notifDepTicket = ''

          if (!refreshPage) {
            this.myTicketPage = 2
          }
        }
        // this.render = false
        // this.$nextTick(() => {
        //   this.render = true
        // })
      }).catch((err) => {
        console.error("CATCH", err);
        this.$mySweetDefaultTost("عملیات ناموفق", "خطایی رخ داد", "error", 2000);
      })
    },

    collapseLeftSide() {
      this.showLeftSide = !this.showLeftSide;
      this.setcollapseSlideBarChatRoom(this.showLeftSide);
    },

    imageDownload(messageId, src, attachmentId) {

      let img = document.getElementById(messageId);
      let record = this.chatMessage.find((x) => x.Id == messageId);
      record.isDownload = true;
      record.downloading = true;
      record.src = src;
      img.onload = () => (record.downloading = false);

    },

    fileDownload(attachmentId, item) {
      var fileLink = document.createElement('a')
      fileLink.href = this.url + item.FileSrc
      document.body.appendChild(fileLink)
      fileLink.target = '_blank'
      fileLink.click()
    },

    showFullSizeImg(messageId) {
      let fullPage = document.getElementById('fullpage')
      let img = document.getElementById(messageId)
      fullPage.style.backgroundImage = "url('" + img.src + "')"
      fullPage.style.display = 'block'
    },

    scoreChangeNew(chatMessageId, score) {
      this.signalRChatConnection
        .invoke("b_UpdateScoreChatTicket", String(chatMessageId), String(score))
        .then((res) => {
          this.$toasted.success("امتیاز شما با موفقیت ثبت شد", {
            action: {
              text: "بستن",
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
              },
            },
          });
        })
        .catch((error) => {
          this.$toasted.error("مشکل در بروزرسانی امتیاز تیکت لطفا مجدد تلاش کنید", {
            action: {
              text: "بستن",
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
              },
            },
          });
          console.error("CATCH", error);
        });
    },
    backToCatsPage() {
      this.getCats();
      this.propsColumn = [{ name: "Name", label: "نام", visibility: true }];
      this.$store.state.renderComponentGrid = false;
      this.$nextTick(() => {
        this.$store.state.renderComponentGrid = true;
      });
      this.isCatsPage = true;
      this.answerCatId = null;
      this.catsName = null;
    },
    getReply(props) {
      this.DataaxiosDepUser.Action = "TicketAnswer/B_GetReply";
      this.DataaxiosDepUser.Method = "Get";
      this.DataaxiosDepUser.ArryfildValue = {
        Id: props.Id,
      };
      this.$GetData_Header(this.DataaxiosDepUser)
        .then((res) => {
          this.propsRows = res;
          this.propsColumn = [
            { name: "Subject", label: "موضوع", visibility: true },
            { name: "Reply", label: "ریپلای", visibility: true },
          ];
          this.$store.state.renderComponentGrid = false;
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true;
          });
          this.isCatsPage = false;
          this.answerCatId = props.Id;
          this.catsName = props.Name;
        })
        .catch((err) => {
          this.$mySweetDefaultTost("عملیات ناموفق", "خطایی رخ داد", "error", 2000);
          console.error("CATCH", err);
        });
    },
    getCats() {
      this.DataaxiosDepUser.Action = "TicketAnswer/B_GetCats";
      this.DataaxiosDepUser.Method = "Get";
      this.DataaxiosDepUser.ArryfildValue = null;
      this.$PostData(this.DataaxiosDepUser)
        .then((data) => {
          this.propsRows = data;
          this.$store.state.renderComponentGrid = false;
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true;
          });
        })
        .catch((err) => {
          this.$mySweetDefaultTost("عملیات ناموفق", "خطایی رخ داد", "error", 2000);
          console.error("CATCH", err);
        });
    },

    OnDetailCustomer(ev) {
      this.$FindeCustomerById('DetailCustomer',this.CId ,false,ev)
      // this.$router.push({ name: "DetailCustomer", params: { tblCustomerId: this.CId } });
    },
    GetResultremotAccess(data) {
      if ((data.id != null) & (data.element != null)) {
        this.remotAccess = data.id;
        var anydesk = data.element.element;
        var fileLink = document.createElement("a");
        fileLink.href = "anydesk:" + anydesk;
        document.body.appendChild(fileLink);
        fileLink.click();
      }
    },
    showMoadalInput() {
      this.$bvModal.show("modal-GnerateCode");
    },
    showMoadalReadyAnswers() {
      this.$bvModal.show("modal-ReadyAnswers");
    },
    closeMoadalReadyAnswers() {
      this.$bvModal.hide("modal-ReadyAnswers");
      this.backToCatsPage();
    },
    switchChatRoom(TblChatRoomId, CustomerName, CustomerCode, TicketId, TblComboGrpId41, UserId, TblCustomerId, ticket) {

      this.leftChatRoomOnline_Invoke()
      this.setCookieLastMess()
      this.cancelUpload();
      this.cancelEdit();
      this.cancelReply()

      this.DataaxiosDepUser.Action = "ChatRoom/GetChatRoomMessage";
      this.DataaxiosDepUser.Method = "Post";
      this.DataaxiosDepUser.ArryfildValue = {
        ChatRoomId: TblChatRoomId,
        IsCustomer: this.isCustomer,
      };
      this.$PostData(this.DataaxiosDepUser)
        .then((response) => {
          response.forEach((element) => {
            if (element.TblComboGrpId43 == 1804 || element.TblComboGrpId43 == 2500) {
              element.isDownload = false;
              element.downloading = false;
              element.src = "";
            }
          });
          this.chatMessage = response;
          this.customerName = CustomerName;
          this.customerCode = CustomerCode;
          this.ticketId = TicketId;
          this.tblComboIdTicketStatus = TblComboGrpId41;
          this.chatRoomId = TblChatRoomId;
          this.CId = TblCustomerId;
          this.ticekt = ticket
          this.departmentId = ticket.TblDepartmentId

          this.grp45Id = ticket.TblComboGrpId45
          this.grp42Id = ticket.TblComboGrpId42
          var record = this.myTickets.find((element) => element.Id == TicketId);
          var recordDep = this.DeaprtmentTicket.find((element) => element.Id == TicketId)
          let filtreTicket = this.filterdTickets.find(x => x.Id == TicketId)

          if (filtreTicket != undefined) {
            filtreTicket.UnseenMessage = 0;
          }
          if (record != undefined) {
            record.UnseenMessage = 0;
          }
          if (recordDep != undefined) {
            recordDep.UnseenMessage = 0;
          }
          this.ticketManagerTblUserId = UserId;
          this.IsIdUser = false;
          this.isSwitch = true;
          this.$nextTick(() => {
            this.IsIdUser = true;
          });
          this.messageLinks();

          this.seenFirstMessage()

          this.getCookieLastMess()
          // this.showIconReply()
          this.saveIdLastTicket() 
        })
        .catch((error) => {
          console.error("CATCH", error);
        }).finally(()=>{
          this.checkOnlineUser_Invoke()
        })

      this.$PostData_new('get', 'CustomerInfo/GetGrp37AxarinVazeit/' +  TblCustomerId).then((res)=>{
        this.tblCombogrp37AxarinVazeit = res
      }).catch((error) => {
        console.error("CATCH", error);
        this.$mySweetDefaultTost("عملیات ناموفق", "خطا در خواندن وضعیت مشتری", "error", 2300);        
      })
      
    },
    myTicket() {
      var DataaxiosDepUser = {
        Action: "Ticket/MyTickets/" + this.userId + '/' + this.pageInationMyTickets.page + '/' + this.pageInationMyTickets.pageSize,
        Method: "Get",
        ArryfildValue: {
          Id: this.userId,
        },
      };
      this.$PostData(DataaxiosDepUser)
        .then((response) => {
          //محسابه تعداد صفحات
          this.pageInationMyTickets.totalPage = response.TotalCount / this.pageInationMyTickets.pageSize
          if (!(response.TotalCount % this.pageInationMyTickets.pageSize == 0)) {
            this.pageInationMyTickets.totalPage++
          }
          this.pageInationMyTickets.totalPage = parseInt(this.pageInationMyTickets.totalPage)


          response = response.BvGetTickets

          for (let index = 0; index < response.length; index++) {
            let svgCustomer = createAvatar(style, {
              seed: response[index].TblCustomerId + "",
            });
            var svg64Customer = btoa(unescape(encodeURIComponent(svgCustomer)));
            this.CustomerLogo = "data:image/svg+xml;base64," + svg64Customer;
            response[index].CustomerLogo = this.CustomerLogo;
          }
          this.myTickets = response;
          this.notifMyTicket = ''

          this.$store.state.renderComponentGrid = false;
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true;
          });
        })
        .catch((error) => {
          console.error("CATCH", error);
        });
    },

    GetResulUserId(data) {
      if (this.counter2 > 0 && !this.isSwitch && data.id != null) {
        if (data.IsDefault) {
          return
        }
        this.getUserDepartment(data.id)

        this.submitTicketStatusRequest.TblUserId = data.id

        // let Dataaxios = {
        //   Action: 'Ticket/CheckDepartmentRefrenceTicket',
        //   Method: 'Post',
        //   ArryfildValue: {
        //     userId: data.id,
        //     departmentId: 0,
        //   },
        // }
        // this.ticketManagerTblUserId = data.id

        // let tickId = this.ticketId
        // this.$PostData(Dataaxios).then((res) => {
        //   if (res.isSuccess == true) {

        // this.submitTicketStatusRequest.TblUserId = data.id 
        ////
        // this.signalRTicketConnection
        //   .invoke("ReferenceTicket", String(this.ticketId), String(data.id), String(this.tblUserGrpIdInsert))
        //   .then((res) => {
        //     this.$mySweetDefaultTost("عملیات موفق", "تیکت با موفقیت ارجاع شد", "success", 2000);

        //     this.ticketManagerTblUserId = data.id

        //     if (data.id != this.userId) {
        //       var record = this.myTickets.find((element) => element.Id == this.ticketId);
        //       if (record != undefined) {
        //         const index = this.myTickets.indexOf(record);
        //         this.myTickets.splice(index, 1);
        //       }
        //     }
        //     var recordDep = this.DeaprtmentTicket.find((element) => element.Id == this.ticketId);
        //     if (recordDep != undefined) {
        //       recordDep.TblUserId = data.id;
        //     }
        //   })
        //   .catch((error) => {
        //     this.$mySweetDefaultTost("عملیات ناموفق", "خطایی رخ داد", "error", 2000);
        //     console.error("CATCH", error);
        //   });
        ///
        //   } else {
        //     this.showModalRefrence = true
        //     this.checkRefrenceTicketResult = res
        //     this.changeDepartmentRequest.ticketId = this.ticketId
        //     this.changeDepartmentRequest.userIdTask = data.id
        //   }
        // }).catch((error) => {
        //   this.$mySweetDefaultTost("عملیات ناموفق", "خطایی رخ داد", "error", 2000);
        //   console.error("CATCH", error);
        //   this.modalTicketStatus = false
        // });
      }
      this.isSwitch = false;
      this.counter2++;
    },
    cancelEdit() {
      this.showEditMessage = false;
      this.newMessage = "";
      this.roleForEdit = null;
      this.messageIdForEdit = null;
    },

    editMessage(id, meesage) {
      if (this.$IsAccess("btnEditMessage")) {

        // اگر اولین پیام بود و پشتیبان ایجاد کرده بود نباید پشتیبان بتواند پیام را ویرایش کند
        let length = this.chatMessage.length - 1
        for (let index = 0; index < this.chatMessage.length; index++) {
          const element = this.chatMessage[index];
          if (element.Id == id) {
            if (index == length & element.TblUserGrpIdInsert != this.tblUserGrpIdInsert) {
              return
            }
          }
        }
        let messItem = this.chatMessage.find(x=> x.Id == id)
        // ایجاد کننده  نبود نباید بتواند پیام را ویرایش کند
        if(messItem.TblComboGrpId43 == 1803 || messItem.TblComboGrpId43 == 2500 || messItem.TblComboGrpId43 == 2501){
          if(messItem.TblUserGrpIdInsert != this.tblUserGrpIdInsert){
            return
          }
        }


        if (!this.isCustomer) {
          this.cancelEdit();
          this.showEditMessage = true;
          this.newMessage = meesage;
          this.messageIdForEdit = id;
        }
      }
    },

    previousPage() {
      var page = this.pageInationDepTickets.page
      var totalPage = this.pageInationDepTickets.totalPage
      page--
      if (page > 0) {
        this.pageInationDepTickets.page--
        this.getDeaprtmentTicket(false)
      }

    },
    nextPage() {
      var page = this.pageInationDepTickets.page
      var totalPage = this.pageInationDepTickets.totalPage
      page++
      if (page <= totalPage) {
        this.pageInationDepTickets.page++
        this.getDeaprtmentTicket(false)
      }

    },


    previousPageMyTicket() {
      var page = this.pageInationMyTickets.page
      page--
      if (page > 0) {
        this.pageInationMyTickets.page--
        this.myTicket()
      }

    },
    nextPageMyTicket() {
      var page = this.pageInationMyTickets.page
      var totalPage = this.pageInationMyTickets.totalPage
      page++
      if (page <= totalPage) {
        this.pageInationMyTickets.page++
        this.myTicket()
      }

    },


    changeMessage() {
      this.signalRChatConnection
        .invoke("EditMessage", String(this.messageIdForEdit), this.newMessage, String(this.tblUserGrpIdInsert), String(this.chatRoomId))
        .then((res) => {
          this.cancelEdit();
          this.messageLinks();
          // this.showIconReply()
          this.$mySweetDefaultTost("عملیات موفق", "پیام با موفقیت ویرایش شد", "success", 1000);
        })
        .catch((error) => {
          this.$mySweetDefaultTost("عملیات ناموفق", "خطایی رخ داد", "error", 2000);
          console.error("CATCH", error);
        });
    },

    changeStatus(id, itemId, statusName, item) {

      if (item.TblChatRoomId != this.chatRoomId) {
        this.$mySweetDefaultTost("", "برای تغییر وضعیت تیکت باید تیکت را انتخاب کنید", "info", 3000);
        return;
      }
      this.signalRChatConnection
        .invoke("ChangeStatus", String(this.ticketId), String(id), String(this.tblUserGrpIdInsert), String(this.departmentId), String(this.chatRoomId))
        .then((res) => {
          this.$mySweetDefaultTost("عملیات موفق", "وضعیت تیکت با موفقیت تغییر کرد", "success", 1000);

          var record = this.myTickets.find((element) => element.Id == itemId);
          var recordDep = this.DeaprtmentTicket.find((element) => element.Id == itemId);
          if (record != undefined) {
            record.TblComboGrpId41 = id;
            record.NameGrp41 = statusName;
          }
          if (recordDep != undefined) {
            recordDep.TblComboGrpId41 = id;
            recordDep.NameGrp41 = statusName;
          }
          if (id == 1796) {
            var record = this.myTickets.find((element) => element.Id == this.ticketId);
            const index = this.myTickets.indexOf(record);
            this.myTickets.splice(index, 1);
          }
        })
        .catch((error) => {
          this.$mySweetDefaultTost("عملیات ناموفق", "خطایی رخ داد", "error", 2000);
          console.error("CATCH", error);
        });
    },
    cancelUpload() {
      this.base64 = null;
      this.uploadImageName = "";
      this.imageSize = 0;
      var input = document.getElementById("inputImage");
      if (input != undefined) {
        input.value = "";
        this.fileFormat = "";
        this.isImage = null;
      }
    },
    userDepartment() {
      this.DataaxiosDepUser.Action = "Ticket/GetUserDepartment";
      this.DataaxiosDepUser.Method = "Get";
      this.DataaxiosDepUser.ArryfildValue = null;

      this.$PostData(this.DataaxiosDepUser)
        .then((res) => {
          this.usersByDepartment = res;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getTicketStatus() {
      this.DataaxiosDepUser.Action = "Ticket/GetTicketStatus";
      this.DataaxiosDepUser.Method = "Get";
      this.DataaxiosDepUser.ArryfildValue = null;
      this.$PostData(this.DataaxiosDepUser)
        .then((res) => {
          this.ticketStatus = res;
        })
        .catch((err) => {
          console.error(err);
        });
    },

    validationSendMessage(tblComboGrpId43, withEnter) {
      if (!this.isCustomer & (this.grp45Id == null || this.grp45Id == '')) {
        this.$mySweetDefaultTost("", "ابتدا نوع تیکت را مشخص نمایید", "info", 2500);
        return false
      }
      if (this.newMessage != null) {
        var validMessage = "";
        if (withEnter) {
          validMessage = this.newMessage.replaceAll("\n", "");
        }
        // if (tblComboGrpId43 == 1803) {
        //   this.base64 = null;
        //   this.isImage = null;
        // }
        if (validMessage != null) {
          validMessage = this.newMessage.replace(/\s/g, "");
        }
        if (this.newMessage == null || (validMessage == "" && this.base64 == null)) {
          if (tblComboGrpId43 == 1803) {
            this.$mySweetDefaultTost("", "لطفا یادداشت را وارد نمایید", "info", 1200);
            this.cancelUpload();
          } else {
            this.$mySweetDefaultTost("", "مقادیر را برای ارسال پیام وارد نمایید", "info", 1200);
            this.cancelUpload();
          }
          this.newMessage = "";
          return false;
        } else {
          this.newMessage = this.newMessage.replace(/\n$/, "");
          this.removeCookieLastMess()
          return true;
        }
      } else {
        this.$mySweetDefaultTost("", "مقادیر را برای ارسال پیام وارد نمایید", "info", 1200);
        this.cancelUpload();
      }
    },

    sendMessage(tblComboGrpId43, withEnter, ev) {
      if (ev != undefined) {
        if (ev.shiftKey) {
          if (this.validationSendMessage(tblComboGrpId43, withEnter) && !this.showEditMessage) {
            this.SendingMessage(tblComboGrpId43);
          }
        }
        //اگر با کنترل اینتر بود به عنوان یادداشت ارسال میشود
        if (ev.ctrlKey & !this.isCustomer) {
          if (this.validationSendMessage(1803, withEnter) && !this.showEditMessage) {
            this.SendingMessage(1803);
          }
        }
      } else {
        if (this.validationSendMessage(tblComboGrpId43, withEnter) && !this.showEditMessage) {
          this.SendingMessage(tblComboGrpId43);
        }
      }
    },

    SendingMessage(tblComboGrpId43) {
      if (!this.isCustomer) {
        this.isSendingMesssage = true;
        this.signalRChatConnection
          .invoke("SendMessage", String(this.chatRoomId), String(this.userId), String(0), this.newMessage, String(tblComboGrpId43),
            String(this.tblUserGrpIdInsert), this.base64, this.fileFormat, String(this.isImage), String(this.replyMessageData.id))
          .then((x) => {
            this.cancelUpload();
            this.cancelReply()
            this.newMessage = "";
            this.$bvModal.hide("modal-GnerateCode");
            this.isSendingMesssage = false;
            // this.getNowChatMeesage();
            if (this.myTicketPage == 1) {
              var find = this.myTickets.find(x => x.TblChatRoomId == this.chatRoomId)
              if (find != undefined & tblComboGrpId43 != 1803 & tblComboGrpId43 != 2500 & tblComboGrpId43 != 2501) {
                var index = this.myTickets.indexOf(find)
                this.myTickets.splice(index, 1);
              }
            } else {
              var find = this.DeaprtmentTicket.find(x => x.TblChatRoomId == this.chatRoomId)
              if (find != undefined & tblComboGrpId43 != 1803 & tblComboGrpId43 != 2500 & tblComboGrpId43 != 2501) {
                var index = this.DeaprtmentTicket.indexOf(find)
                this.DeaprtmentTicket.splice(index, 1);
              }
            }
          })
          .catch((error) => {
            console.error("CATCH", error);
            this.$mySweetDefaultTost("عملیات ناموفق", "ارسال پیام با خطا مواجه شد", "error", 2000);
          });
      }
      if (this.isCustomer) {
        this.isSendingMesssage = true;
        this.signalRChatConnection
          .invoke("SendMessage", String(this.chatRoomId), String(0), String(this.userId), this.newMessage, String(tblComboGrpId43),
            String(this.tblUserGrpIdInsert), this.base64, this.fileFormat, String(this.isImage), String(this.replyMessageData.id))
          .then(() => {
            this.cancelUpload();
            this.cancelReply()
            this.newMessage = "";
            this.$bvModal.hide("modal-GnerateCode");
            this.isSendingMesssage = false;
            // this.getNowChatMeesage();
          })
          .catch((error) => {
            console.error("CATCH", error);
            this.$mySweetDefaultTost("عملیات ناموفق", "ارسال پیام با خطا مواجه شد", "error", 2000);
          });
      }
    },

    async uploadImage() {
      var mes = this.newMessage
      this.cancelEdit();
      this.newMessage = mes

      const toBase64 = (file) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
        });

      var input = document.getElementById("inputImage");
      if (input.files.length <= 5) {
        if (input.files.length > 1) {
          let filedata = null;
          let zip = new JSZip();
          this.imageSize = 0;
          this.uploadImageName = "";
          for (let index = 0; index < input.files.length; index++) {
            let lengthSplit = input.files[index].name.split('.').length
            var Checktypes = "." + input.files[index].name.split(".")[lengthSplit - 1].toLowerCase();
            if (this.acceptFile.includes(Checktypes)) {
              this.imageSize += input.files[index].size;
              this.uploadImageName += input.files[index].name + " , ";
              const element = input.files[index];
              let filename = input.files[index].name;
              var folderName = this.$store.state.JalaliDate;
              folderName = folderName.replaceAll("/", "_");
              zip.file(folderName + "/" + filename, element);
            } else {
              let Validformats = "فرمت های معتبر" + "\n";
              this.acceptFile.forEach((element) => {
                element = element.split(".");
                Validformats += element[1] + ", ";
              });
              this.$mySweetDefaultTost("فرمت فایل نامعتبر", Validformats, "info", 6000);
              this.cancelUpload();
              return;
            }
          }
          this.imageSize = Math.round(this.imageSize / 1000);
          if (this.imageSize < 10010) {
            await zip
              .generateAsync({ type: "base64" })
              .then(function (Convertbase64) {
                filedata = "data:application/zip;base64," + Convertbase64;
              })
              .finally(() => {
                this.base64 = filedata;
                this.base64 = this.base64.split(",")[1];
                this.isImage = false;
                this.fileFormat = "zip";
              });
          } else {
            this.$mySweetDefaultTost("عملیات ناموفق", "مجموع حجم فایل ها باید کمتر از 10 مگابایت باشد", "info", 3000);
            this.cancelUpload();
          }
        } else {
          let lengthSplit = input.files[0].name.split('.').length
          var Checktype = "." + input.files[0].name.split(".")[lengthSplit - 1].toLowerCase();
          if (this.acceptFile.includes(Checktype)) {
            var image = input.files[0];

            var imageType = image.type.split("/")[0];
            var imageName = image.name.split(".");
            var imageNameLength = imageName.length;
            this.fileFormat = imageName[imageNameLength - 1];

            this.imageSize = Math.round(image.size / 1000);

            if (this.imageSize < 10010) {
              this.uploadImageName = image.name;
              this.base64 = await toBase64(image);
              this.base64 = this.base64.split(",")[1];

              if (imageType == "image") {
                this.isImage = true;
              } else {
                this.isImage = false;
              }
            } else {
              this.$mySweetDefaultTost("عملیات ناموفق", "حجم فایل باید کمتر از 10 مگابایت باشد", "info", 2500);
              this.cancelUpload();
            }
          } else {
            let Validformats = "فرمت های معتبر" + "\n";
            this.acceptFile.forEach((element) => {
              element = element.split(".");
              Validformats += element[1] + ", ";
            });
            this.$mySweetDefaultTost("فرمت فایل نامعتبر", Validformats, "info", 6000);
            this.cancelUpload();
          }
        }
      } else {
        this.$mySweetDefaultTost("عملیات ناموفق", "حداکثر تعداد فایل انتخابی 5 عدد است", "info", 2500);
      }
    },
  },
};
</script>

<style scoped>
/* @media screen and (max-width: 1024px) {
    .leftSide {
        display: none;
    }
} */

.chat_input textarea {
  border-radius: 5px;
  padding-right: 5px;
  padding-top: 5px;
  resize: none;
  /* background-color: whitesmoke !important; */
  background: var(--sidebar-bg-color);
  color: var(--sidebar-color-item);
  position: relative;
  width: 90%;
  margin: 0px 0px;
  padding: 10px 20px;
}

.pagination {
  background: var(--sidebar-bg-color);
  color: var(--sidebar-color-item);
}



* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.body {
  direction: ltr;
  display: flex;
  justify-content: center;
  align-items: center;
  /* min-height: 85vh; */
  height: 85vh;
  background: linear-gradient(#009688 0%, #009688 130px, #d9dbd5 130px, #d9dbd5 100%);
}

.container {
  position: relative;
  width: 100%;
  max-width: 100%;
  /* height: calc(100vh - 40px); */
  height: 100%;
  /* background: #fff; */
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.06), 0 2px 5px 0 rgba(0, 0, 0, 0.06);
  display: flex;
  /* overflow-x: scroll; */
  /* overflow-y: scroll; */
}

.container .leftSide {
  position: relative;
  flex: 30%;
  background: #fff;
  border-right: 1px solid rgba(0, 0, 0, 0.2);
  min-width: 310px;
}

.container .rightSide {
  position: relative;
  flex: 70%;
  background: #e5ddd5;
  min-width: 330px;
}

.container .rightSide::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* background: url("images/pattern.png"); */
  /* background-color: black; */
  opacity: 0.06;
}

.header {
  position: relative;
  width: 100%;
  height: 60px;
  /* background: #ededed; */
  background: var(--sidebar-bg-color);
  color: var(--sidebar-color-item);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;
}

.userimg {
  position: relative;
  width: 40px;
  height: 40px;
  overflow: hidden;
  border-radius: 50%;
  cursor: pointer;
}

.cover {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.nav_icons {
  display: flex;
}

.nav_icons li {
  display: flex;
  list-style: none;
  cursor: pointer;
  color: #51585c;
  font-size: 1.5em;
  margin-left: 22px;
}

.search_chat {
  position: relative;
  width: 100%;
  height: 50px;
  background: #f6f6f6;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 15px;
}

.search_chat div {
  width: 100%;
}

.search_chat div input {
  width: 100%;
  outline: none;
  border: none;
  background: #fff;
  padding: 6px;
  height: 38px;
  border-radius: 30px;
  font-size: 14px;
  padding-left: 40px;
}

.search_chat div input::placeholder {
  color: #bbb;
}

.search_chat div ion-icon {
  position: absolute;
  left: 30px;
  top: 14px;
  font-size: 1.2em;
}

.chatlist {
  background: var(--sidebar-action-bg) !important;
  position: relative;
  /* height: 100%; */
  /* height: calc(100% - 120px); */
  height: calc(89%);
  /* height: calc(100%); */
  /* height: 85vh; */
  /* height: calc(100% - 120px); */

  overflow: auto;
}

.chatlist p {
  color: var(--sidebar-color-item) !important;
}

.chatlist h4 {
  color: var(--logo-color) !important;
}

.chatlist .block {
  background: var(--sidebar-action-bg) !important;
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 15px;
  border-bottom: 1px solid var(--sidebar-bg-color) !important;
  cursor: pointer;
}

.chatlist .block.active {
  /* background: red ; */
  background: var(--sidebar-bg-color) !important;
  /* color: var(--sidebar-color-item) !important; */
  border-left: 4px solid var(--logo-color) !important;
}

.chatlist .block:hover {
  /* background: #f5f5f5; */
  background: var(--sidebar-bg-color) !important;
}

.chatlist .block .imgBox {
  position: relative;
  min-width: 45px;
  height: 45px;
  overflow: hidden;
  border-radius: 50%;
  margin-right: 10px;
}

.chatlist .block .details {
  position: relative;
  width: 100%;
}

.chatlist .block .details .listHead {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
}

.chatlist .block .details .listHead h4 {
  font-size: 1.1em;
  font-weight: 600;
  color: #111;
}

.chatlist .block .details .listHead .time {
  font-size: 0.75em;
  color: #aaa;
}

.chatlist .block .details .listHead .time {
  color: #111;
}

.chatlist .block.unread .details .listHead .time {
  color: #06d755;
}

.message_p {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.message_p b {
  background: #06d755;
  color: #fff;
  min-width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.75rem;
}

.message_p p {
  color: #aaa;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  font-size: 0.9em;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.imgText {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.imgText h4 {
  font-weight: 500;
  line-height: 1.2em;
  margin-left: 15px;
}

.imgText h4 span {
  font-size: 0.8em;
  color: #555;
}

/* CHAT BOX */
.chatbox {
  background: var(--sidebar-action-bg);
  position: relative;
  /* display: flex;
  flex-direction: column-reverse; */
  width: 100%;
  height: calc(100% - 160px);
  padding: 10px;
  overflow-y: auto;
}

.sortMessage {
  display: flex;
  flex-direction: column-reverse;
}

.message {
  position: relative;
  display: flex;
  width: 100%;
  margin: 5px 0;
}

.message p {
  position: relative;
  right: 0;
  text-align: right;
  max-width: 65%;
  padding: 12px;
  background: #dcf8c8;
  border-radius: 10px;
  font-size: 0.9em;
}

.message p::before {
  /* content: ""; */
  position: absolute;
  top: 0;
  right: -12px;
  width: 20px;
  height: 20px;
  background: linear-gradient(135deg, #dcf8c6 0%, #dcf8c6 50%, transparent 50%, transparent);
}

.message p span {
  display: block;
  margin-top: 5px;
  font-size: 0.85em;
  opacity: 0.5;
}

.my_msg {
  justify-content: flex-end;
}

.friend_msg {
  justify-content: flex-start;
}

.friend_msg p {
  background: #fff;
  text-align: left;
}

.message.friend_msg p::before {
  /* content: ""; */
  position: absolute;
  top: 0;
  left: -12px;
  width: 20px;
  height: 20px;
  background: linear-gradient(225deg, #fff 0%, #fff 50%, transparent 50%, transparent);
}

.chat_input {
  position: relative;
  width: 100%;
  height: 90px;
  /* background: #f0f0f0; */
  background: var(--sidebar-bg-color);
  /* padding: 15px; */
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1.2em;
}

.chat_input ion-icon {
  cursor: pointer;
  font-size: 1.8em;
  color: #51585c;
}

.chat_input ion-icon:nth-child(1) {
  margin-right: 15px;
}

.chat_input input {
  position: relative;
  width: 90%;
  margin: 0 0px;
  padding: 10px 20px;
  border: none;
  outline: none;
  border-radius: 30px;
  font-size: 1em;
}

/*---------------------------------------------*/

p {
  overflow-x: hidden !important;
  font-family: "IRANSansWeb", sans-serif;
  line-height: 1.49rem;
  white-space: pre-wrap;
  word-wrap: break-word;
  text-align: justify !important;
  direction: rtl !important;
  color: #111 !important;
}

.note {
  background-color: #9af1f1 !important;
}

i {
  cursor: pointer;
}

#fullpage {
  display: none;
  position: absolute;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-size: contain;
  background-repeat: no-repeat no-repeat;
  background-position: center center;
  background-color: black;
}

.img {
  border: 10px;
}

.chatlist span,
.chatbox span {
  display: block;
  margin-top: 5px;
  font-size: 0.85em;
  opacity: 0.5;
  font-size: 0.8em;
  color: #555;
}

#sender {
  font-size: 1em;
  color: #555;
}

figcaption {
  width: 100%;
  margin-top: -10px;
  background: #dcf8c8;
  padding: 10px;
  border-radius: 0 0 0.5rem 0.5rem;
  word-wrap: break-word !important;
  white-space: pre-wrap !important;
}

.fa-times:hover {
  color: #ff6868 !important;
  text-shadow: #dfa6a6;
}

.imageName {
  border-radius: 5px;
  overflow: hidden;
  background: rgb(209, 208, 212);
  width: 100%;
}

/* span,
p,
figcaption,
textarea {
    color: #111 !important;
} */

.chatlist span,
.chatbox span,
p,
figcaption {
  color: #111 !important;
}

a {
  text-decoration: none;
}

.gallery img {
  min-width: 100%;
  min-height: 300px;
  max-height: 300px;
  background-color: #eef8ff;
}

.chat_input i,
.header i {
  color: var(--sidebar-color-item) !important;
}

.containerImg {
  position: relative;
}

.imageHover {
  display: block;
}

.overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
  transition: 0.3s ease;
  /* background-color: red; */
}

.containerImg .overlay {
  opacity: 1;
}

.icon {
  color: rgb(209, 208, 212);
  font-size: 50px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  text-align: center;
}

.icon i:hover {
  color: #1b5172;
  transition: 0.3s;
}

.icon span {
  color: #1d8fda !important;
  font-size: 24px;
}

.icon i {
  color: #0b213236;
}

.pointer {
  cursor: pointer !important;
}

.refresh-page {
  background: var(--sidebar-action-bg);
}

.refresh-page i {
  color: var(--sidebar-color-item) !important;
}

.header-info {
  background: var(--sidebar-bg-color);
}

.header-info i {
  color: var(--sidebar-color-item);
}

.fa-reply {
  color: var(--sidebar-color-item);
}

.reply-mess {
  border-radius: 5px;
  overflow: hidden;
  background: #bef498;
  width: 100%;
  direction: rtl !important;
}

.reply-img {
  border: 2px solid 06d755;
  background-color: #bef498;
  border-radius: 5px;
  font-size: 10px;
  padding: 4px;
  font-style: italic;
  cursor: pointer;
  color: #153147;
  height: 30px;
}

.figure-caption {
  direction: rtl !important;
}


  .Content{
    margin-bottom:100px !important ;
    
  }


</style>
